var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBimg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 250.23,
    cy: 316.83,
    rx: 243.48,
    ry: 159.67,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-2",
    points: "266.86 470.53 377.73 406.4 201.26 304.53 90.39 368.65 266.86 470.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M55.54,287.13l62.08-35.84c.68-.39.68-1,0-1.42l-4.46-2.57a2.73,2.73,0,0,0-2.46,0L85.5,261.85a2.71,2.71,0,0,1-2.45,0L37.1,235.32a2.71,2.71,0,0,0-2.45,0l-2.16,1.25c-.68.39-.68,1,0,1.42l46,26.55a.75.75,0,0,1,0,1.42L48.63,283.14a.75.75,0,0,0,0,1.42l4.46,2.57A2.65,2.65,0,0,0,55.54,287.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 352.18,
    cy: 434.95,
    rx: 38.42,
    ry: 24.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 110.84,
    cy: 410.66,
    rx: 46.79,
    ry: 29.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 175.08,
    cy: 248.82,
    rx: 41.98,
    ry: 26.32,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boards--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.82 228.58 98.82 227.74 65.75 246.95 66.46 247.37 98.82 228.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.56,181a.2.2,0,0,1,.1.22L35.32,236,35,237.52a.9.9,0,0,1-.49-.1h0l-.83-.48a.21.21,0,0,1-.09-.22l12.67-56.24a.2.2,0,0,1,.29-.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.11,180.21,36.38,236.72a.36.36,0,0,1-.16.22l-.83.48a.83.83,0,0,1-.43.1l.36-1.55L47.69,181Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,278.32V280a1,1,0,0,1-.46-.1h0l-.77-.44a.33.33,0,0,1-.18-.27v-93L65,187Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.46,186.15v93a.34.34,0,0,1-.19.25l-.77.44A.87.87,0,0,1,65,280V187Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,256.75a.94.94,0,0,1-.44-.13l-.79-.45a.4.4,0,0,1-.19-.28L88.6,176.63l1.42.82,14.79,77.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.53,255.93h0a.33.33,0,0,1-.19.27l-.73.42,0,0a.91.91,0,0,1-.47.11l-.3-1.59L90,177.45l1.43-.82,15.07,79.23h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.97 249.28 100.24 229.4 100.24 227.76 65.97 247.64 65.97 249.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34,208.77V210a2.1,2.1,0,0,0,.93,1.63l9.85,5.68a2.08,2.08,0,0,0,1.88,0L112,181a2.1,2.1,0,0,0,.93-1.63v-1.22a2.08,2.08,0,0,0-.93-1.62l-9.85-5.69a2.08,2.08,0,0,0-1.88,0l-63,36.3A2.08,2.08,0,0,0,36.34,208.77Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.27,208.23l9.85,5.69a2.08,2.08,0,0,0,1.88,0l63-36.3a.57.57,0,0,0,0-1.08l-9.85-5.69a2.08,2.08,0,0,0-1.88,0l-63,36.3A.57.57,0,0,0,37.27,208.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06,214.14v3.39a1.86,1.86,0,0,1-.93-.23l-9.85-5.68a2.09,2.09,0,0,1-.94-1.63v-1.22a2.1,2.1,0,0,1,.75-1.49c-.33.3-.26.69.19.95l9.85,5.69A2,2,0,0,0,48.06,214.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,211.86l-2.74-1.58a3.72,3.72,0,0,1-1.67-2.7l-5.65-97.94a3.18,3.18,0,0,1,1.46-2.7L96.69,71.36a3.52,3.52,0,0,1,3.13,0L102.56,73a3.72,3.72,0,0,1,1.67,2.7l5.65,97.94a3.21,3.21,0,0,1-1.46,2.7L46.69,211.86A3.43,3.43,0,0,1,43.57,211.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19,75.38a1,1,0,0,0-1.63-.63L40.83,110.32a3,3,0,0,0-1.08,1.18l-5.86-3.38A3,3,0,0,1,35,106.94L96.7,71.37a3.44,3.44,0,0,1,3.11,0L102.57,73A3.77,3.77,0,0,1,104.19,75.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.37,113,45,211a1,1,0,0,0,1.67.89l61.73-35.57a3.21,3.21,0,0,0,1.46-2.7l-5.65-97.94a1,1,0,0,0-1.67-.9L40.83,110.32A3.21,3.21,0,0,0,39.37,113Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,84.76V90a1.42,1.42,0,0,1-.66,1.13l-19.15,11a1.51,1.51,0,0,1-1.31,0l-1.62-.94a1.47,1.47,0,0,1-.66-1.14V97.46l-5.86-3.38-2.93,1.68v-6A1.42,1.42,0,0,1,55,88.62l19.15-11a1.44,1.44,0,0,1,1.31,0l10.41,6A1.42,1.42,0,0,1,86.54,84.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,84.76V90a1.45,1.45,0,0,1-.66,1.13l-19.15,11a1.36,1.36,0,0,1-.65.15V95.55a1.36,1.36,0,0,0,.65-.16l19.15-11c.32-.18.36-.47.12-.67A1.45,1.45,0,0,1,86.54,84.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,89.37l10.41,6a1.44,1.44,0,0,0,1.31,0l19.15-11c.37-.2.37-.54,0-.75l-10.41-6a1.44,1.44,0,0,0-1.31,0L55,88.62C54.64,88.83,54.64,89.17,55,89.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.39,170,59,167.87a.68.68,0,0,1,1.1.59l1.11,19.06a2.11,2.11,0,0,1-.95,1.77l-3.62,2.09a.68.68,0,0,1-1.1-.59l-1.11-19.06A2.08,2.08,0,0,1,55.39,170Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.85,195l3.62-2.09c.57-.33,1.05-.19,1.08.3a1.9,1.9,0,0,1-1,1.49L57,196.75c-.57.33-1.05.19-1.08-.3A1.9,1.9,0,0,1,56.85,195Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,171.87l3.62-2.09a.67.67,0,0,1,1.09.59l.58,10a2.11,2.11,0,0,1-1,1.77L69,184.23a.68.68,0,0,1-1.1-.59l-.58-10A2.1,2.1,0,0,1,68.29,171.87Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,171.87l3.62-2.09a.67.67,0,0,1,1.09.59l.58,10a2.11,2.11,0,0,1-1,1.77L69,184.23a.68.68,0,0,1-1.1-.59l-.58-10A2.1,2.1,0,0,1,68.29,171.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,187.81l3.62-2.09c.57-.33,1-.19,1.08.3a1.9,1.9,0,0,1-1,1.49l-3.62,2.09c-.57.33-1,.19-1.08-.3A1.9,1.9,0,0,1,69.21,187.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,150.18l3.62-2.09a.67.67,0,0,1,1.09.59L86,173.22A2.14,2.14,0,0,1,85,175l-3.62,2.09a.67.67,0,0,1-1.09-.59L78.89,152A2.11,2.11,0,0,1,79.85,150.18Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,150.18l3.62-2.09a.67.67,0,0,1,1.09.59L86,173.22A2.14,2.14,0,0,1,85,175l-3.62,2.09a.67.67,0,0,1-1.09-.59L78.89,152A2.11,2.11,0,0,1,79.85,150.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.57,180.66l3.62-2.09c.57-.33,1-.19,1.08.3a1.9,1.9,0,0,1-1,1.49l-3.62,2.09c-.57.33-1.05.19-1.08-.3A1.9,1.9,0,0,1,81.57,180.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84,153.87l3.62-2.09a.67.67,0,0,1,1.09.59l.76,13.7a2.14,2.14,0,0,1-1,1.77l-3.62,2.09a.67.67,0,0,1-1.09-.59l-.76-13.7A2.13,2.13,0,0,1,92.84,153.87Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84,153.87l3.62-2.09a.67.67,0,0,1,1.09.59l.76,13.7a2.14,2.14,0,0,1-1,1.77l-3.62,2.09a.67.67,0,0,1-1.09-.59l-.76-13.7A2.13,2.13,0,0,1,92.84,153.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,173.51l3.62-2.09c.57-.33,1-.19,1.08.3a1.9,1.9,0,0,1-1,1.49L94,175.3c-.57.33-1.05.19-1.08-.3A1.9,1.9,0,0,1,93.93,173.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5,122.21c.51,8.51-5,19-12.2,23.24s-13.37.79-13.82-7.75c-.41-7.94,4.29-17.52,10.73-22.25l0,.63.39.22c-6.11,4.32-10.43,13.37-10.22,20.85.24,8.27,6,11.47,12.84,7.19,6.56-4.12,11.74-13.64,11.32-21.57a.78.78,0,0,1,.2-.58C76,122,76.42,121.89,76.5,122.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8,121.52c-.49-9.31-7.24-13.09-15.06-8.44a27.13,27.13,0,0,0-9.09,9.7l2.29,1.65A20.91,20.91,0,0,1,63,117c6-3.58,11.22-.66,11.59,6.5S70.33,139.37,64.31,143s-11.22.67-11.6-6.5l-3.25,1.94c.48,9.31,7.24,13.09,15.05,8.44S78.29,130.82,77.8,121.52Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,120.15c-4.55,2.71-8,9.3-7.73,14.72s4.21,7.61,8.76,4.9,8-9.3,7.73-14.72S67.67,117.43,63.12,120.15Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.12,120.15c-4.55,2.71-8,9.3-7.73,14.72s4.21,7.61,8.76,4.9,8-9.3,7.73-14.72S67.67,117.43,63.12,120.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.34,94.74l-14.1,8.39A2.69,2.69,0,0,0,80,105.32c0,.76.67,1,1.41.59l14.1-8.4a2.68,2.68,0,0,0,1.26-2.18C96.71,94.56,96.08,94.3,95.34,94.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.72,101.92l-14.1,8.39a2.71,2.71,0,0,0-1.27,2.19c0,.77.68,1,1.42.59l14.09-8.39a2.7,2.7,0,0,0,1.27-2.19C97.09,101.75,96.46,101.48,95.72,101.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.09,109.11,82,117.5a2.7,2.7,0,0,0-1.27,2.19c0,.76.67,1,1.41.59l14.1-8.4a2.69,2.69,0,0,0,1.27-2.18C97.47,108.93,96.83,108.67,96.09,109.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.47,116.29l-14.1,8.39a2.69,2.69,0,0,0-1.26,2.19c0,.77.67,1,1.41.59l14.1-8.39a2.69,2.69,0,0,0,1.26-2.19C97.84,116.11,97.21,115.85,96.47,116.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,123.48l-14.1,8.39a2.69,2.69,0,0,0-1.27,2.18c0,.77.68,1,1.42.59L97,126.25a2.69,2.69,0,0,0,1.27-2.18C98.22,123.3,97.59,123,96.85,123.48Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.39,59.67l-.88.5V181.53c0,2.87,1.74,6.2,3.89,7.45L421,258a2.56,2.56,0,0,0,2.44.26c.19-.09.86-.49,1-.58a3.42,3.42,0,0,0,1.33-3.13V133.2Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,258,301.4,189c-2.15-1.25-3.89-4.58-3.89-7.45V60.17l127.37,73.54V255.07C424.88,257.93,423.13,259.25,421,258Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sticky-notes--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--notes-shadows--inject-2",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "386.71 208.41 378 203.39 378 189.98 386.71 195.01 386.71 208.41"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.35 215.72 390.65 210.69 390.65 197.28 399.35 202.31 399.35 215.72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "412 223.02 403.29 217.99 403.29 204.58 412 209.61 412 223.02"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.71 226.85 378 221.82 378 208.41 386.71 213.44 386.71 226.85"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.27 233.23 390.96 229.57 389.88 217.1 400.19 220.76 401.27 233.23"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.95 241.8 404.24 236.77 404.24 223.36 412.95 228.39 412.95 241.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Note--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.81,202.94l6,3.36c.67.38,1.11-.7,1.11-1.36.68.43,2.05.7,2.12-.16l.56-7.6L377.57,192Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.57 191.95 386.62 197.18 386.62 195.5 377.57 190.28 377.57 191.95",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.78 205.24 383.3 206.34 384.07 204.31 385.78 205.24",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "389.46 210.24 398.47 215.37 399.27 204.48 390.22 199.25 389.46 210.24",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.22 199.25 399.27 204.48 399.27 202.81 390.22 197.58 390.22 199.25",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.22 199.25 399.27 204.48 399.27 202.81 390.22 197.58 390.22 199.25",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.86 236.42 411.86 241.55 412.67 230.66 403.62 225.44 402.86 236.42",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.62 225.44 412.67 230.66 412.67 228.99 403.62 223.76 403.62 225.44",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.62 225.44 412.67 230.66 412.67 228.99 403.62 223.76 403.62 225.44",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.79 230.16 400.53 233.68 399.48 222.82 389.67 219.2 390.79 230.16",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.67 219.2 399.48 222.82 399.19 221.16 389.38 217.55 389.67 219.2",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.67 219.2 399.48 222.82 399.19 221.16 389.38 217.55 389.67 219.2",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.81 221.25 385.81 226.38 386.62 215.49 377.57 210.26 376.81 221.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.57 210.27 386.62 215.49 386.62 213.82 377.57 208.59 377.57 210.27",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.57 210.27 386.62 215.49 386.62 213.82 377.57 208.59 377.57 210.27",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.11,217.54l6,3.37c.67.37,1.11-.71,1.12-1.37.67.43,2.05.7,2.12-.15l.56-7.61-9.06-5.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.86 206.56 411.92 211.78 411.92 210.11 402.86 204.88 402.86 206.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.07 219.84 408.59 220.94 409.37 218.92 411.07 219.84",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.53 200.1 347.74 168.47 347.74 106.09 402.53 137.72 402.53 200.1",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.29,199.4l.25-.15a1.6,1.6,0,0,0,.73-1.26V139.32a1.62,1.62,0,0,0-.73-1.26L347.72,107.5a1.63,1.63,0,0,0-1.46,0l-.25.15a1.62,1.62,0,0,0-.73,1.26v58.67a1.6,1.6,0,0,0,.73,1.26l52.82,30.56A1.63,1.63,0,0,0,400.29,199.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,139.32V198a1.63,1.63,0,0,1-.72,1.27l-.25.14a1.67,1.67,0,0,1-1.3.08c.33.09.57-.1.57-.5V140.31a1.43,1.43,0,0,0-.22-.72l1.72-1A1.63,1.63,0,0,1,401.26,139.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,108.49l52.82,30.56a1.6,1.6,0,0,1,.73,1.26V199c0,.46-.33.65-.73.42L346,168.84a1.6,1.6,0,0,1-.73-1.26V108.91C345.28,108.45,345.61,108.26,346,108.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,164c1.78,1,4.51,1.24,6.56-3.78s3.9-9.07,6.41-7.38c1.76,1.18,1.52,2.79,3.1,3.7,2.47,1.42,4.4-4.71,5.27-10.44,1.24-8.12,2.43-10.25,4.65-9,3.29,1.82,3,7.23,3,12.2,0,4.45,0,6.77,2.41,7.76,1.6.65,3.16-3.21,3.79-6.18s2-4.41,3.46-3.59,3,2.79,3,10.67c.07,7,.18,17,.3,19.16a10.86,10.86,0,0,0,5.79,9.29v7.91L348.6,166.74Z",
    style: {
      fill: "#BDDEF7",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,186.84a11.33,11.33,0,0,1-6-9.68c-.13-2.3-.24-13-.3-19.19-.08-7.69-1.54-9.52-2.8-10.25a1,1,0,0,0-.94-.08c-.75.34-1.42,1.59-1.8,3.35-.53,2.48-1.68,5.66-3.17,6.45a1.48,1.48,0,0,1-1.28.08c-2.72-1.12-2.72-3.64-2.72-8.21v-1.1c0-4.48,0-9.12-2.76-10.67-.65-.37-1-.27-1.19-.18-1.34.66-2.17,5.08-2.74,8.86-.34,2.23-1.65,9.62-4.24,10.87a1.84,1.84,0,0,1-1.76-.09,4.31,4.31,0,0,1-1.65-1.92,4.3,4.3,0,0,0-1.47-1.79,1.36,1.36,0,0,0-1.22-.26c-1.64.5-3.28,4.49-4.47,7.41-1,2.46-2.28,4-3.8,4.48a4.1,4.1,0,0,1-3.45-.46l.48-.84a3.22,3.22,0,0,0,2.66.38c1.24-.42,2.32-1.74,3.21-3.93,1.7-4.15,3.16-7.38,5.09-8a2.34,2.34,0,0,1,2,.38,5.25,5.25,0,0,1,1.78,2.14,3.44,3.44,0,0,0,1.29,1.54.84.84,0,0,0,.85.05c1.39-.67,2.88-4.74,3.7-10.14.94-6.2,1.86-8.88,3.28-9.58a2.14,2.14,0,0,1,2.08.2c3.3,1.82,3.28,6.76,3.26,11.53v1.09c0,4.42,0,6.44,2.12,7.31a.52.52,0,0,0,.46,0c.92-.49,2.07-3,2.67-5.8.46-2.12,1.29-3.55,2.36-4a1.92,1.92,0,0,1,1.81.12c1.58.91,3.21,2.94,3.29,11.08.06,6.17.17,16.87.3,19.15a10.28,10.28,0,0,0,5.54,8.89Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.15,186.84a11.33,11.33,0,0,1-6-9.68c-.13-2.3-.24-13-.3-19.19-.08-7.69-1.54-9.52-2.8-10.25a1,1,0,0,0-.94-.08c-.75.34-1.42,1.59-1.8,3.35-.53,2.48-1.68,5.66-3.17,6.45a1.48,1.48,0,0,1-1.28.08c-2.72-1.12-2.72-3.64-2.72-8.21v-1.1c0-4.48,0-9.12-2.76-10.67-.65-.37-1-.27-1.19-.18-1.34.66-2.17,5.08-2.74,8.86-.34,2.23-1.65,9.62-4.24,10.87a1.84,1.84,0,0,1-1.76-.09,4.31,4.31,0,0,1-1.65-1.92,4.3,4.3,0,0,0-1.47-1.79,1.36,1.36,0,0,0-1.22-.26c-1.64.5-3.28,4.49-4.47,7.41-1,2.46-2.28,4-3.8,4.48a4.1,4.1,0,0,1-3.45-.46l.48-.84a3.22,3.22,0,0,0,2.66.38c1.24-.42,2.32-1.74,3.21-3.93,1.7-4.15,3.16-7.38,5.09-8a2.34,2.34,0,0,1,2,.38,5.25,5.25,0,0,1,1.78,2.14,3.44,3.44,0,0,0,1.29,1.54.84.84,0,0,0,.85.05c1.39-.67,2.88-4.74,3.7-10.14.94-6.2,1.86-8.88,3.28-9.58a2.14,2.14,0,0,1,2.08.2c3.3,1.82,3.28,6.76,3.26,11.53v1.09c0,4.42,0,6.44,2.12,7.31a.52.52,0,0,0,.46,0c.92-.49,2.07-3,2.67-5.8.46-2.12,1.29-3.55,2.36-4a1.92,1.92,0,0,1,1.81.12c1.58.91,3.21,2.94,3.29,11.08.06,6.17.17,16.87.3,19.15a10.28,10.28,0,0,0,5.54,8.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,152.88c0,1.71,3.37,10.7,10.95,11.16s10.38-8,14.06-6,3,8.08,6.4,10.15,7.1-9.51,11.23-7.67,2.7,14.5,5.15,16.81v17L348.6,166.74Z",
    style: {
      fill: "#BDDEF7",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,177.72c-1.18-1.11-1.51-4-1.9-7.27-.47-4-1-8.51-3.11-9.45-1.78-.79-3.64,1.62-5.45,4s-3.8,4.92-5.84,3.68c-1.82-1.09-2.55-3.18-3.26-5.2s-1.41-4-3.13-4.94c-1.34-.73-2.54.21-4.54,1.94-2.25,1.94-5,4.36-9.31,4.09-7.66-.47-11.38-9.47-11.4-11.64h1c0,1.43,3.1,10.23,10.49,10.68,3.87.23,6.5-2,8.61-3.85,2-1.69,3.65-3.15,5.65-2.06s2.82,3.33,3.57,5.47c.69,1.94,1.33,3.78,2.85,4.69,1.3.78,2.89-1.27,4.58-3.45,1.94-2.5,4.14-5.34,6.6-4.25,2.62,1.17,3.16,5.77,3.68,10.22.34,2.86.68,5.82,1.6,6.69Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,116.83a2.77,2.77,0,0,1,1.25,2.16c0,.8-.56,1.12-1.25.72a2.75,2.75,0,0,1-1.24-2.16C350.42,116.76,351,116.44,351.66,116.83Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,119.27a2,2,0,0,0,.92,1.53l8.51,4.91c.51.29.92.08.92-.47a2,2,0,0,0-.92-1.52l-8.51-4.91C354.28,118.51,353.87,118.72,353.86,119.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,122.81a2.74,2.74,0,0,1,1.25,2.16c0,.79-.56,1.11-1.25.72a2.78,2.78,0,0,1-1.24-2.16C350.42,122.73,351,122.41,351.66,122.81Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,122.81a2.74,2.74,0,0,1,1.25,2.16c0,.79-.56,1.11-1.25.72a2.78,2.78,0,0,1-1.24-2.16C350.42,122.73,351,122.41,351.66,122.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,125.24a2,2,0,0,0,.92,1.53l8.51,4.91c.51.29.92.08.92-.47a2,2,0,0,0-.92-1.52l-8.51-4.91C354.28,124.48,353.87,124.69,353.86,125.24Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "369.54 215.33 351.68 205.01 351.68 174.98 369.54 185.29 369.54 215.33",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.23,215.61l-17-9.79a1,1,0,0,1-.45-.78V176c0-.29.2-.4.45-.26l17,9.8a1,1,0,0,1,.45.77v29C368.68,215.64,368.48,215.75,368.23,215.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,190,353,182.15a1,1,0,0,1-.51-.7c0-.23.23-.28.51-.12l13.53,7.81a1,1,0,0,1,.5.7C367,190.07,366.8,190.12,366.52,190Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,192.1,353,184.29a1,1,0,0,1-.51-.7c0-.23.23-.28.51-.12l13.53,7.81a1,1,0,0,1,.5.7C367,192.21,366.8,192.26,366.52,192.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,196.55,353,188.73a1,1,0,0,1-.51-.7c0-.23.23-.28.51-.12l13.53,7.81a1,1,0,0,1,.5.71C367,196.65,366.8,196.71,366.52,196.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,198.69,353,190.87a1,1,0,0,1-.51-.7c0-.23.23-.28.51-.12l13.53,7.81a1,1,0,0,1,.5.7C367,198.79,366.8,198.85,366.52,198.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,205.27,353,197.46a1,1,0,0,1-.51-.71c0-.22.23-.28.51-.12l13.53,7.82a1,1,0,0,1,.5.7C367,205.38,366.8,205.43,366.52,205.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,203.13,353,195.32a1,1,0,0,1-.51-.71c0-.22.23-.28.51-.12l13.53,7.82a1,1,0,0,1,.5.7C367,203.24,366.8,203.29,366.52,203.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pushpin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.76,183.42l0,0,.06,0s.07,0,.11,0l.34-.2c.14-.08.31-.17.48-.28l.55-.34c.05,0-.05-.21-.11-.18l-.56.3-.49.27-.34.2s-.08,0-.08.08a.11.11,0,0,0,0,.08Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,183.67c.27.45.7.7,1.15.46l0,0h0a.52.52,0,0,0,.19-.44,1.52,1.52,0,0,0-.69-1.19.5.5,0,0,0-.46-.06h0l0,0A.83.83,0,0,0,358.41,183.67Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M358.41,183.67c.27.45.7.7,1.15.46l0,0h0a.52.52,0,0,0,.19-.44,1.52,1.52,0,0,0-.69-1.19.5.5,0,0,0-.46-.06h0l0,0A.83.83,0,0,0,358.41,183.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.86,184.57l-.51-.87a4.85,4.85,0,0,0,1.08-.74s0,0,0,0v0h0a.29.29,0,0,1,.34,0,1,1,0,0,1,.45.77.3.3,0,0,1-.13.29h0l-.09,0A4.64,4.64,0,0,0,357.86,184.57Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,183.87a.54.54,0,0,1,.53-.54.58.58,0,0,1,.19,0h0l.09,0a1.19,1.19,0,0,1,.54.94.61.61,0,0,1,0,.14.55.55,0,0,1-.53.44.54.54,0,0,1-.54-.54.43.43,0,0,0,0-.05A.52.52,0,0,1,356.92,183.87Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.92,183.87a.54.54,0,0,1,.53-.54.58.58,0,0,1,.19,0h0l.09,0a1.19,1.19,0,0,1,.54.94.61.61,0,0,1,0,.14.55.55,0,0,1-.53.44.54.54,0,0,1-.54-.54.43.43,0,0,0,0-.05A.52.52,0,0,1,356.92,183.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,183.6c-.3-.18-.54,0-.54.31a1.19,1.19,0,0,0,.54.94c.3.17.54,0,.54-.31A1.19,1.19,0,0,0,357.45,183.6Z",
    style: {
      fill: "#BDDEF7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "422.14 177.16 404.28 166.84 404.28 136.81 422.14 147.12 422.14 177.16",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.84,177.44l-17-9.79a1,1,0,0,1-.45-.78v-29c0-.29.2-.4.45-.26l17,9.79a1,1,0,0,1,.45.78v29C421.29,177.47,421.09,177.58,420.84,177.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,151.79,405.59,144a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12L419.12,151a1,1,0,0,1,.5.7C419.62,151.9,419.4,152,419.12,151.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,153.93l-13.53-7.81a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.5.7C419.62,154,419.4,154.09,419.12,153.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,158.38l-13.53-7.82a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.5.7C419.62,158.48,419.4,158.54,419.12,158.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,160.52l-13.53-7.82a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.5.7C419.62,160.62,419.4,160.68,419.12,160.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,167.1l-13.53-7.81a1,1,0,0,1-.5-.71c0-.22.22-.28.5-.12l13.53,7.82a1,1,0,0,1,.5.7C419.62,167.2,419.4,167.26,419.12,167.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,165l-13.53-7.81a1,1,0,0,1-.5-.71c0-.22.22-.28.5-.12l13.53,7.82a1,1,0,0,1,.5.7C419.62,165.07,419.4,165.12,419.12,165Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.37,145.25l0,0,.06,0c.05,0,.07,0,.12,0l.34-.2.48-.28.54-.34c.05,0-.05-.21-.11-.18l-.56.3-.49.27-.34.2s-.08,0-.08.08a.22.22,0,0,0,0,.08Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,145.5a.84.84,0,0,0,1.14.46l0,0h0a.5.5,0,0,0,.19-.44,1.52,1.52,0,0,0-.69-1.19.49.49,0,0,0-.46-.06h0l0,0A.83.83,0,0,0,411,145.5Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M411,145.5a.84.84,0,0,0,1.14.46l0,0h0a.5.5,0,0,0,.19-.44,1.52,1.52,0,0,0-.69-1.19.49.49,0,0,0-.46-.06h0l0,0A.83.83,0,0,0,411,145.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,146.4l-.51-.87a4.87,4.87,0,0,0,1.07-.74l0,0,0,0h0a.28.28,0,0,1,.34,0,1,1,0,0,1,.44.77.3.3,0,0,1-.13.29h0s-.05,0-.08,0A4.46,4.46,0,0,0,410.47,146.4Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.52,145.7a.54.54,0,0,1,.54-.54.65.65,0,0,1,.19,0h0l.08,0a1.19,1.19,0,0,1,.54.94.66.66,0,0,1,0,.14.53.53,0,0,1-1.06-.1v0A.53.53,0,0,1,409.52,145.7Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52,145.7a.54.54,0,0,1,.54-.54.65.65,0,0,1,.19,0h0l.08,0a1.19,1.19,0,0,1,.54.94.66.66,0,0,1,0,.14.53.53,0,0,1-1.06-.1v0A.53.53,0,0,1,409.52,145.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,145.43c-.3-.18-.55,0-.55.31a1.2,1.2,0,0,0,.55.94c.3.17.54,0,.54-.31A1.19,1.19,0,0,0,410.06,145.43Z",
    style: {
      fill: "#BDDEF7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.87 203.62 303.89 180.54 303.89 109.23 343.87 132.31 343.87 203.62",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.7 170.38 302.72 147.3 302.72 109.98 342.7 133.06 342.7 170.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.23 165.39 304.2 144.02 304.2 114.73 341.23 136.1 341.23 165.39",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.23 165.39 304.2 144.02 304.2 114.73 341.23 136.1 341.23 165.39",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.2 129.31 341.23 150.68 341.23 165.39 304.2 144.02 304.2 129.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,150.68l-21.65-12.5s-8.67-2.53-6.76.53,9.27,5.32,13.05,12.74c2.94,5.77,15.36,12,15.36,12Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,150.68l-21.65-12.5s-8.67-2.53-6.76.53,9.27,5.32,13.05,12.74c2.94,5.77,15.36,12,15.36,12Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.19,139.69s-8.37-16.14-10.78-18.51-3.51.67-4.14.4-3.07-6.85-3.07-6.85V129.3Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.19,139.69s-8.37-16.14-10.78-18.51-3.51.67-4.14.4-3.07-6.85-3.07-6.85V129.3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.33,145a6.39,6.39,0,0,0-2.45-2.88c-1.72-1-4.2-3.2-4.9-5.27s-2.67-7-4.61-7.75-6.32,5.35-6.32,5.35Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,137.18c0-1.89,1-2.85,2.23-2.14s2.22,2.82,2.22,4.71-1,2.85-2.22,2.14S334.28,139.07,334.28,137.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "341.56 171.12 301.45 147.96 301.45 182.37 341.56 205.53 341.56 171.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.7 170.46 342.7 204.86 341.56 205.53 341.56 171.12 342.7 170.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.45 147.96 302.59 147.3 342.7 170.46 341.56 171.12 301.45 147.96",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "301.45 147.96 302.59 147.3 342.7 170.46 341.56 171.12 301.45 147.96",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "342.7 170.46 341.56 171.12 341.56 177.74 342.7 177.07 342.7 170.46",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "342.7 170.46 341.56 171.12 341.56 177.74 342.7 177.07 342.7 170.46",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "341.56 177.74 301.45 154.58 301.45 147.96 341.56 171.12 341.56 177.74",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.83,179.87c0,.37-.27.51-.61.31l-3-1.74a1.29,1.29,0,0,1-.62-1c0-.36.28-.5.62-.31l3,1.74A1.3,1.3,0,0,1,338.83,179.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.76,176.94c0,.37-.27.51-.61.31l-3-1.73a1.34,1.34,0,0,1-.61-1c0-.36.28-.5.61-.31l3,1.74A1.3,1.3,0,0,1,333.76,176.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69,174c0,.37-.28.51-.61.31l-3-1.73a1.31,1.31,0,0,1-.61-1c0-.36.27-.5.61-.31l3,1.74A1.32,1.32,0,0,1,328.69,174Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,171.08c0,.37-.28.51-.62.31l-3-1.73a1.31,1.31,0,0,1-.61-1c0-.36.27-.5.61-.31l3,1.74A1.33,1.33,0,0,1,323.62,171.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.54,168.15c0,.37-.27.51-.61.31l-3-1.73a1.34,1.34,0,0,1-.61-1c0-.36.28-.5.61-.3l3,1.73A1.31,1.31,0,0,1,318.54,168.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,165.23c0,.36-.27.5-.61.3l-3-1.73a1.31,1.31,0,0,1-.61-1c0-.36.27-.5.61-.3l3,1.73A1.31,1.31,0,0,1,313.47,165.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,162.3c0,.36-.28.5-.61.31l-3-1.74a1.3,1.3,0,0,1-.61-1c0-.37.27-.51.61-.31l3,1.73A1.32,1.32,0,0,1,308.4,162.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.57 183.35 334.88 181.22 334.88 184.55 338.57 186.73 338.57 183.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.57 188.02 334.88 185.9 334.88 189.22 338.57 191.4 338.57 188.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.57 192.69 334.88 190.57 334.88 193.89 338.57 196.07 338.57 192.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.57 197.36 334.88 195.24 334.88 198.56 338.57 200.74 338.57 197.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 180.42 329.8 178.29 329.8 181.62 333.5 183.8 333.5 180.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 185.09 329.8 182.97 329.8 186.29 333.5 188.47 333.5 185.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 189.76 329.8 187.63 329.8 190.96 333.5 193.14 333.5 189.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 194.43 329.8 192.31 329.8 195.63 333.5 197.81 333.5 194.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.42 177.49 324.73 175.36 324.73 178.69 328.42 180.87 328.42 177.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.42 182.16 324.73 180.03 324.73 183.36 328.42 185.54 328.42 182.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.42 186.83 324.73 184.7 324.73 188.03 328.42 190.21 328.42 186.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.42 191.5 324.73 189.38 324.73 192.7 328.42 194.88 328.42 191.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.34 174.56 319.65 172.43 319.65 175.76 323.34 177.93 323.34 174.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.34 179.23 319.65 177.1 319.65 180.43 323.34 182.6 323.34 179.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.34 183.9 319.65 181.77 319.65 185.1 323.34 187.28 323.34 183.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.34 188.57 319.65 186.44 319.65 189.77 323.34 191.95 323.34 188.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.26 171.62 314.57 169.5 314.57 172.82 318.26 175 318.26 171.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.26 176.29 314.57 174.17 314.57 177.5 318.26 179.67 318.26 176.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.26 180.97 314.57 178.84 314.57 182.17 318.26 184.34 318.26 180.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.26 185.64 314.57 183.51 314.57 186.84 318.26 189.01 318.26 185.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 168.69 309.5 166.57 309.5 169.89 313.19 172.07 313.19 168.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 173.36 309.5 171.24 309.5 174.56 313.19 176.74 313.19 173.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 178.03 309.5 175.91 309.5 179.24 313.19 181.41 313.19 178.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 182.71 309.5 180.58 309.5 183.91 313.19 186.08 313.19 182.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.11 165.76 304.42 163.64 304.42 166.96 308.11 169.14 308.11 165.76",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.11 170.43 304.42 168.31 304.42 171.63 308.11 173.81 308.11 170.43",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.11 175.1 304.42 172.98 304.42 176.31 308.11 178.48 308.11 175.1",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.11 179.77 304.42 177.65 304.42 180.98 308.11 183.15 308.11 179.77",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.52,162.45l-.29.61a.07.07,0,0,1-.1,0l-.64-.24c-.1,0-.14.1-.07.24l.47.87a.27.27,0,0,1,0,.17l-.11.79c0,.13.09.29.18.28l.58-.07a.13.13,0,0,1,.11.07l.58.73c.09.12.2.08.18-.07l-.11-.91a.13.13,0,0,1,0-.13l.46-.34c.08,0,0-.24-.07-.32l-.64-.5a.23.23,0,0,1-.09-.14l-.29-.94C304.69,162.43,304.56,162.35,304.52,162.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,183a1.6,1.6,0,0,1,1-1.56c.83-.3,1.53.36,2,.92.14.15-.11.22-.22.11-.53-.5-1.52-1-2.09-.33s-.28,1.67,0,2.4a3.42,3.42,0,0,0,3.14,2.29c3.1-.24-.26-5.69-2.09-6-.15,0-.26-.26-.06-.29.93-.15,1.59.68,2.17,1.3a7.08,7.08,0,0,1,1.48,2.36c.62,1.64-.29,3.67-2.3,3A4.35,4.35,0,0,1,318.83,183Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,181a4.36,4.36,0,0,1,.56-.65c.07-.08.25,0,.21.13s-.33.4-.46.63a1,1,0,0,0-.08.11,3.74,3.74,0,0,1,1.3-.43,4.57,4.57,0,0,1,2.66.24c.09,0,.05.11,0,.12a.87.87,0,0,1-.39-.07,5,5,0,0,0-1.39-.1,4.62,4.62,0,0,0-1.95.5,1.29,1.29,0,0,1,1.24.31s0,.11,0,.12a7.72,7.72,0,0,1-.83-.06,3.38,3.38,0,0,0-1,.17c-.13,0-.22-.09-.22-.2A2,2,0,0,1,324.43,181Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.85,124.49l0,0s0,0,.06,0,.06,0,.11,0l.34-.2.48-.29.54-.33c.06,0,0-.22-.11-.19l-.56.3-.48.28-.35.19s-.08,0-.08.08,0,.06,0,.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,124.74a.84.84,0,0,0,1.15.46s0,0,0,0h0a.5.5,0,0,0,.19-.44,1.54,1.54,0,0,0-.68-1.19.5.5,0,0,0-.46-.06h0l0,0A.84.84,0,0,0,321.5,124.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,125.64l-.51-.87a4.64,4.64,0,0,0,1.07-.74l0,0h0a.28.28,0,0,1,.34,0,1,1,0,0,1,.44.77.3.3,0,0,1-.13.29h0a.11.11,0,0,1-.08,0A4.84,4.84,0,0,0,321,125.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,124.94a.54.54,0,0,1,.54-.54.65.65,0,0,1,.19,0h0l.08,0a1.21,1.21,0,0,1,.55.94.59.59,0,0,1,0,.14.53.53,0,0,1-1.06-.09v-.06A.53.53,0,0,1,320,124.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,124.67c-.3-.18-.55,0-.55.31a1.2,1.2,0,0,0,.55.94c.3.17.54,0,.54-.31A1.19,1.19,0,0,0,320.54,124.67Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.51,137.48l3-5.17L298.13,57.05h0a1.46,1.46,0,0,0-1.53.12,4.66,4.66,0,0,0-2.1,3.65,1.5,1.5,0,0,0,.57,1.33h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.88,136.1a4.66,4.66,0,0,1,2.11-3.65c1.16-.67,2.1-.12,2.1,1.22a4.65,4.65,0,0,1-2.1,3.65C425.82,138,424.88,137.45,424.88,136.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.75 115.18 322.89 104.87 322.89 74.83 340.75 85.15 340.75 115.18",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.45,115.47l-17-9.8a1,1,0,0,1-.45-.78v-29a.28.28,0,0,1,.45-.26l17,9.8a1,1,0,0,1,.45.78v29C339.9,115.49,339.7,115.61,339.45,115.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,89.82,324.2,82a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12L337.73,89a1,1,0,0,1,.51.71C338.24,89.92,338,90,337.73,89.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,92,324.2,84.14a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.71C338.24,92.06,338,92.12,337.73,92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,96.4,324.2,88.59a1,1,0,0,1-.5-.7c0-.23.22-.29.5-.13l13.53,7.82a1,1,0,0,1,.51.7C338.24,96.51,338,96.56,337.73,96.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,98.54,324.2,90.73a1,1,0,0,1-.5-.71c0-.22.22-.28.5-.12l13.53,7.82a1,1,0,0,1,.51.7C338.24,98.65,338,98.7,337.73,98.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,105.12,324.2,97.31a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C338.24,105.23,338,105.28,337.73,105.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,103,324.2,95.17a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C338.24,103.09,338,103.14,337.73,103Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330,83.28l0,0,.07,0s.06,0,.11,0l.34-.2.48-.29c.17-.1.36-.21.54-.33s0-.22-.11-.19l-.56.31-.49.27-.34.19s-.08,0-.08.09,0,0,0,.07Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63,83.52c.26.46.69.71,1.15.46h0a.48.48,0,0,0,.19-.44,1.54,1.54,0,0,0-.68-1.19.53.53,0,0,0-.46-.06l0,0,0,0A.84.84,0,0,0,329.63,83.52Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.63,83.52c.26.46.69.71,1.15.46h0a.48.48,0,0,0,.19-.44,1.54,1.54,0,0,0-.68-1.19.53.53,0,0,0-.46-.06l0,0,0,0A.84.84,0,0,0,329.63,83.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.08,84.42l-.51-.86a4.79,4.79,0,0,0,1.07-.75h0l0,0h0a.32.32,0,0,1,.34,0,1,1,0,0,1,.44.78.32.32,0,0,1-.13.29h0l-.08,0A4.84,4.84,0,0,0,329.08,84.42Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,83.72a.54.54,0,0,1,.54-.53.63.63,0,0,1,.19,0h0l.08,0a1.23,1.23,0,0,1,.55.94.59.59,0,0,1,0,.14.53.53,0,0,1-1.06-.09v-.05A.55.55,0,0,1,328.13,83.72Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.13,83.72a.54.54,0,0,1,.54-.53.63.63,0,0,1,.19,0h0l.08,0a1.23,1.23,0,0,1,.55.94.59.59,0,0,1,0,.14.53.53,0,0,1-1.06-.09v-.05A.55.55,0,0,1,328.13,83.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.67,83.45c-.3-.17-.55,0-.55.31a1.2,1.2,0,0,0,.55.94c.3.18.54,0,.54-.31A1.19,1.19,0,0,0,328.67,83.45Z",
    style: {
      fill: "#BDDEF7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "337.78 86.21 336.31 85.36 336.31 79.78 337.78 80.63 337.78 86.21",
    style: {
      fill: "#BDDEF7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.13 103.27 302.27 92.96 302.27 62.92 320.13 73.24 320.13 103.27",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,103.56l-17-9.8a1,1,0,0,1-.45-.78V64c0-.29.21-.41.45-.26l17,9.79a1,1,0,0,1,.45.78v29C319.28,103.58,319.08,103.7,318.83,103.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,77.91,303.58,70.1a1,1,0,0,1-.5-.71c0-.22.22-.28.5-.12l13.53,7.82a1,1,0,0,1,.51.7C317.62,78,317.39,78.07,317.11,77.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,80.05l-13.53-7.81a1,1,0,0,1-.5-.71c0-.22.22-.28.5-.12l13.53,7.82a1,1,0,0,1,.51.7C317.62,80.15,317.39,80.21,317.11,80.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,84.49l-13.53-7.81a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C317.62,84.6,317.39,84.65,317.11,84.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,86.63l-13.53-7.81a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C317.62,86.74,317.39,86.79,317.11,86.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,93.21,303.58,85.4a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C317.62,93.32,317.39,93.38,317.11,93.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.11,91.07l-13.53-7.81a1,1,0,0,1-.5-.7c0-.23.22-.28.5-.12l13.53,7.81a1,1,0,0,1,.51.7C317.62,91.18,317.39,91.24,317.11,91.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.36,71.37l0,0,.07,0s.06,0,.11,0l.34-.2.48-.28.54-.34c.06,0,0-.22-.11-.19l-.56.31-.49.27-.34.2s-.08,0-.08.08,0,0,0,.07Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,71.61c.26.46.69.71,1.15.46h0a.48.48,0,0,0,.19-.44,1.55,1.55,0,0,0-.68-1.19.53.53,0,0,0-.46-.06l0,0,0,0A.84.84,0,0,0,309,71.61Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309,71.61c.26.46.69.71,1.15.46h0a.48.48,0,0,0,.19-.44,1.55,1.55,0,0,0-.68-1.19.53.53,0,0,0-.46-.06l0,0,0,0A.84.84,0,0,0,309,71.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.46,72.52l-.51-.87a5,5,0,0,0,1.07-.74s0,0,0,0l0,0h0a.3.3,0,0,1,.34,0,1,1,0,0,1,.44.77.32.32,0,0,1-.13.29h0l-.08,0A4.36,4.36,0,0,0,308.46,72.52Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.51,71.81a.54.54,0,0,1,.54-.53.63.63,0,0,1,.19,0h0l.08,0a1.2,1.2,0,0,1,.55.94.51.51,0,0,1,0,.13.53.53,0,0,1-1.06-.09v0A.55.55,0,0,1,307.51,71.81Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.51,71.81a.54.54,0,0,1,.54-.53.63.63,0,0,1,.19,0h0l.08,0a1.2,1.2,0,0,1,.55.94.51.51,0,0,1,0,.13.53.53,0,0,1-1.06-.09v0A.55.55,0,0,1,307.51,71.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,71.54c-.3-.17-.55,0-.55.32a1.23,1.23,0,0,0,.55.94c.3.17.54,0,.54-.32A1.22,1.22,0,0,0,308.05,71.54Z",
    style: {
      fill: "#BDDEF7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "317.16 74.3 315.69 73.45 315.69 67.88 317.16 68.72 317.16 74.3",
    style: {
      fill: "#BDDEF7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "341.77 126.5 333.06 121.47 333.06 108.06 341.77 113.09 341.77 126.5",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.6,121.05l6,3.37c.67.37,1.11-.71,1.11-1.36.67.43,2,.69,2.12-.16l.56-7.6-9.05-5.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.36 110.07 341.41 115.3 341.41 113.62 332.36 108.39 332.36 110.07",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.57 123.36 338.09 124.45 338.86 122.43 340.57 123.36",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.28,282.69l16.31-9.41a9.87,9.87,0,0,1,9,0l16.31,9.41a9.93,9.93,0,0,1,4.49,7.78V368l-25.29,14.6L415.79,368V290.47A9.93,9.93,0,0,1,420.28,282.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.08,305.07a9.93,9.93,0,0,0-4.49-7.78l-16.31-9.41c-2.48-1.44-4.49-.27-4.49,2.59V368l25.29,14.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.37,290.47V368l-25.29,14.6V305.07a9.61,9.61,0,0,0-1.83-5.23l25.28-14.6A9.62,9.62,0,0,1,466.37,290.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.9 301.22 438.98 313.39 438.97 341.4 417.9 329.23 417.9 301.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.9 301.22 438.98 313.39 438.97 341.4 417.9 329.23 417.9 301.22",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.72 325.87 423.72 304.56 438.98 313.39 438.97 334.69 423.72 325.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.72 325.87 417.9 329.23 438.97 341.4 438.97 334.69 423.72 325.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,303l.77,3.72.84.48a2.56,2.56,0,0,0,2.58,0l.16-.09.32-1.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.19,308.88l.78,3.78.84.48a2.58,2.58,0,0,0,2.58,0l.16-.09.32-1.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.3,275.86c0-2.8-2.12-5.62-5.8-7.75a34.27,34.27,0,0,0-30.82,0c-3.68,2.13-5.8,4.95-5.8,7.75v3.45c0,2.8,2.12,5.62,5.8,7.75a34.27,34.27,0,0,0,30.82,0c3.68-2.13,5.8-4.95,5.8-7.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,287.27a31.74,31.74,0,0,1-15.41-3.66c-3.68-2.13-5.8-4.95-5.8-7.75s2.12-5.62,5.8-7.75a34.27,34.27,0,0,1,30.82,0c3.68,2.13,5.8,4.95,5.8,7.75s-2.12,5.62-5.8,7.75A31.85,31.85,0,0,1,441.09,287.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.21,271.12V226.31c.45-3.74-1.78-7.56-6.72-10.41-9.06-5.23-23.74-5.23-32.8,0-4.54,2.62-6.8,6.06-6.79,9.49h0v47.73H418c.42,3.06,2.65,6.06,6.71,8.41,9.06,5.23,23.74,5.23,32.8,0,4.06-2.35,6.29-5.35,6.71-8.41h0V273A8.35,8.35,0,0,0,464.21,271.12Z",
    style: {
      fill: "#BDDEF7",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,282.47A30.35,30.35,0,0,1,426.18,279c-3.08-1.78-4.94-4-5.25-6.24l-.05-.43V241.4c0-2.44,1.92-5,5.3-6.91a33.25,33.25,0,0,1,29.82,0c3.66,2.11,5.57,4.83,5.25,7.47l0,.18V271.3l0,.18a4.5,4.5,0,0,1,0,1.16l0,.19C460.87,275,459,277.2,456,279A30.35,30.35,0,0,1,441.09,282.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,234.49A31.28,31.28,0,0,0,441.09,231a35.26,35.26,0,0,0-14.91,3.53c-3.39,1.59-5.33,4.43-5.3,7.47s1.91,5.88,5.3,7.47A35.26,35.26,0,0,0,441.09,253,30.35,30.35,0,0,0,456,249.43c3.66-2.11,5.25-4.73,5.25-7.47C461.42,239.13,459.75,236.55,456,234.49Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,236.78a31.85,31.85,0,0,1-15.41-3.66c-3.68-2.13-5.8-5-5.8-7.75s2.12-5.62,5.8-7.75a34.27,34.27,0,0,1,30.82,0c3.68,2.13,5.8,4.95,5.8,7.75s-2.12,5.62-5.8,7.75A31.85,31.85,0,0,1,441.09,236.78Z",
    style: {
      fill: "#BDDEF7",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,301.38l-.9.52,0,.07a1.29,1.29,0,0,0-.16.66,3.08,3.08,0,0,0,1.39,2.4,1.33,1.33,0,0,0,.65.19l0,.07.9-.52h0a1,1,0,0,0,.41-.89,3.08,3.08,0,0,0-1.39-2.41A1,1,0,0,0,433,301.38Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,301.38l-.9.52,0,.07a1.29,1.29,0,0,0-.16.66,3.08,3.08,0,0,0,1.39,2.4,1.33,1.33,0,0,0,.65.19l0,.07.9-.52h0a1,1,0,0,0,.41-.89,3.08,3.08,0,0,0-1.39-2.41A1,1,0,0,0,433,301.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,304.4c0,.88-.62,1.24-1.39.8a3.08,3.08,0,0,1-1.39-2.41c0-.88.62-1.24,1.39-.8A3.08,3.08,0,0,1,434.47,304.4Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.8,295.55l-.9.52.05.08a1.14,1.14,0,0,0-.16.65,3.09,3.09,0,0,0,1.38,2.41,1.26,1.26,0,0,0,.65.18l0,.08.9-.52h0a1,1,0,0,0,.41-.9,3.06,3.06,0,0,0-1.39-2.4A1,1,0,0,0,422.8,295.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27,298.57c0,.89-.62,1.25-1.39.8a3.06,3.06,0,0,1-1.38-2.4c0-.88.62-1.24,1.38-.8A3.06,3.06,0,0,1,424.27,298.57Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.2,141h0l0,0h0l2.81-1.67h0l0,0h0c2.78-1.4,6.49-1,10.48,1.58,8,5.17,14.16,17.09,13.69,26.62-.23,4.75-2.05,8-4.82,9.45h0l0,0h0l-2.81,1.67h0c-2.78,1.42-6.49,1-10.49-1.57-8-5.17-14.15-17.09-13.69-26.62C440.61,145.71,442.44,142.45,445.2,141Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.79,178.53,467.4,177h0l0,0c2.77-1.44,4.59-4.7,4.82-9.45a29.73,29.73,0,0,0-2.89-13.36l-2.82,1.67a29.48,29.48,0,0,1,2.9,13.36C469.22,173.82,467.46,177,464.79,178.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.07,177.08c-8-5.17-14.15-17.09-13.69-26.62s7.34-13.07,15.37-7.91,14.15,17.09,13.69,26.62S462.1,182.25,454.07,177.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.8,176.41c4.73.23,5.5-5.09,5.61-7.38.41-8.41-5.23-19.37-12.3-23.92a10.72,10.72,0,0,0-5.09-1.89c-4.73-.23-5.5,5.09-5.61,7.39-.41,8.4,5.23,19.36,12.3,23.92a10.7,10.7,0,0,0,5.09,1.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.33,162a1.4,1.4,0,0,1-.17-.22,1.88,1.88,0,0,1-.35-.89V148.68c0-.29.23-.25.52.08a2.12,2.12,0,0,1,.51,1.11v10.66l5.68-.73c.17,0,.49.31.72.74s.26.81.09.83l-6.6.86C454.64,162.24,454.48,162.13,454.33,162Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.42,167.58a.35.35,0,0,1-.07-.09.67.67,0,0,1-.15-.44l2.86-6.32c0-.08.15,0,.27.16s.18.37.14.44l-2.85,6.33C451.59,167.72,451.51,167.68,451.42,167.58Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.16,158.82a3.84,3.84,0,0,1,1.81,3c.06,1.18-.66,1.75-1.61,1.27a3.91,3.91,0,0,1-1.81-3C452.5,158.9,453.22,158.34,454.16,158.82Z",
    style: {
      fill: "#BDDEF7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "284.11 164.18 280.5 166.27 190.17 114.11 193.78 112.03 231.72 133.93 235.34 136.02 237.14 137.06 237.15 137.06 280.5 162.1 284.11 164.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 54.23 235.34 138.1 231.72 136.02 231.72 52.14 235.34 54.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.15 53.19 237.15 137.06 237.14 137.06 235.34 138.1 235.34 54.23 237.15 53.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 54.23 231.72 52.15 233.53 51.1 237.14 53.19 235.34 54.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,53.19l-3.62-2.1L186.56,24V116.2l97.55,56.32V80.3ZM280.5,166.27l-90.33-52.16V30.24l3.62,2.08h0l37.93,21.9h0l3.6,2.08h0l1.8,1h0l43.35,25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.5 82.39 280.5 162.1 237.15 137.06 237.15 57.36 280.5 82.39",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.5 82.39 280.5 162.1 237.15 137.06 237.15 57.36 280.5 82.39",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.72 54.23 231.72 133.93 193.78 112.03 193.79 32.33 231.72 54.23",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.72 54.23 231.72 133.93 193.78 112.03 193.79 32.33 231.72 54.23",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.79 32.32 193.79 32.33 193.78 112.03 190.17 114.11 190.17 30.24 193.79 32.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.56 23.98 190.17 21.89 287.73 78.22 284.11 80.3 186.56 23.98",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.73 78.22 284.11 80.3 284.11 172.52 287.72 170.44 287.73 78.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 56.31 231.73 54.23 231.73 56.32 235.34 58.4 235.34 56.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 58.4 237.14 57.36 235.34 56.31 235.34 58.4",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.11 80.03 280.5 92.4 280.47 162.1 259.07 149.72 259.11 80.03",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.5 105.45 259.1 93.08 259.11 85.86 280.5 98.23 280.5 105.45",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.49 118.7 259.1 106.33 259.1 99.1 280.5 111.47 280.49 118.7",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.49 131.95 259.09 119.58 259.1 112.35 280.49 124.72 280.49 131.95",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.48 145.19 259.09 132.82 259.09 125.6 280.49 137.97 280.48 145.19",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.48 158.44 259.08 146.07 259.09 138.84 280.48 151.22 280.48 158.44",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.78 144.36 259.07 149.72 259.1 102.72 249.8 97.35 249.78 144.36",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,65V53.81L211.4,51V62.17l-5.05-2.93V48.12l-12.54-7.25v71.18l27.48,15.86v-60Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "215.02 83.55 218.15 85.36 218.15 72.74 215.02 70.93 215.02 83.55"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.48 80.34 212.61 82.15 212.61 69.54 209.48 67.73 209.48 80.34"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "215.02 102.43 218.15 104.23 218.15 91.62 215.02 89.81 215.02 102.43"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.48 99.23 212.61 101.03 212.61 88.42 209.48 86.61 209.48 99.23"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "215.02 121.31 218.15 123.12 218.15 110.5 215.02 108.69 215.02 121.31"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.48 118.11 212.61 119.92 212.61 107.3 209.48 105.49 209.48 118.11"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.01 76.03 205.14 77.84 205.14 65.22 202.01 63.42 202.01 76.03"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 72.83 199.6 74.64 199.6 62.02 196.46 60.22 196.46 72.83"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.01 94.91 205.14 96.72 205.14 84.11 202.01 82.3 202.01 94.91"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 91.71 199.6 93.52 199.6 80.91 196.46 79.1 196.46 91.71"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.01 113.79 205.14 115.6 205.14 102.99 202.01 101.18 202.01 113.79"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 110.59 199.6 112.4 199.6 99.79 196.46 97.98 196.46 110.59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267,321.25a.93.93,0,0,0,.93-.93V260.5a.93.93,0,0,0-1.86,0v59.82A.93.93,0,0,0,267,321.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,299.48a.93.93,0,0,0,.87-.59l18.34-46.43a.93.93,0,0,0-1.73-.69L229.1,298.2a.94.94,0,0,0,.52,1.21A.83.83,0,0,0,230,299.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.17,293.9a.92.92,0,0,0,.67-.29L267,257.49l34.07,36a.93.93,0,1,0,1.35-1.27L267.65,255.5a.91.91,0,0,0-.67-.3h0a.93.93,0,0,0-.68.3l-34.81,36.83a.94.94,0,0,0,0,1.32A1,1,0,0,0,232.17,293.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,299.48a.83.83,0,0,0,.34-.07.93.93,0,0,0,.52-1.21l-18.34-46.43a.93.93,0,1,0-1.73.69l18.34,46.43A1,1,0,0,0,304,299.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,292.47l-2.43,6.4a.78.78,0,0,0,0,.16v.12c0,.13.19.29.37.4a1.65,1.65,0,0,0,1.47,0,.63.63,0,0,0,.29-.3h0l0-.09,2.25-6Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,292.47l2.43,6.4a.78.78,0,0,1,0,.16v.12c0,.13-.19.29-.37.4a1.65,1.65,0,0,1-1.47,0,.63.63,0,0,1-.29-.3h0l0-.09-2.25-6Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,315.69V321a.54.54,0,0,0,.32.44,1.67,1.67,0,0,0,1.51,0,.54.54,0,0,0,.32-.44v-5.29A2.28,2.28,0,0,0,265.9,315.69Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,254.64c0-1.41,1.23-2.9,3.83-4.59,4.8-3.11,15.53-9.36,22.25-13.09a.05.05,0,0,1,.05-.05c5.17-3.14,10-18.08,13.57-29.43,1.22-3.87,2.72-6.06,4.49-7.09l2.31-1.3c3.51-2.11,8.12.42,13.86,3.56,5.29,2.89,9.42,6.6,10.25,16.43.5,6,0,17.42-1.19,26.09h0c-1.76,14.48-3.92,14.5-7.06,16.93-5.39,4.17-17.55,10-22.67,12-9.3,3.66-16.89-2-22.55-4.77a132.12,132.12,0,0,1-15-8.89c-1.42-1-2.15-2.07-2.13-3.16C232,256.87,232,255.09,232,254.64Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,254.64c0-1.41,1.23-2.9,3.83-4.59,4.8-3.11,15.53-9.36,22.25-13.09a.05.05,0,0,1,.05-.05c5.17-3.14,10-18.08,13.57-29.43,1.22-3.87,2.72-6.06,4.49-7.09l2.31-1.3c3.51-2.11,8.12.42,13.86,3.56,5.29,2.89,9.42,6.6,10.25,16.43.5,6,0,17.42-1.19,26.09h0c-1.76,14.48-3.92,14.5-7.06,16.93-5.39,4.17-17.55,10-22.67,12-9.3,3.66-16.89-2-22.55-4.77a132.12,132.12,0,0,1-15-8.89c-1.42-1-2.15-2.07-2.13-3.16C232,256.87,232,255.09,232,254.64Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,200.27c3.48-1.82,8,.66,13.59,3.72,3.58,2,6.64,4.29,8.49,8.65l2.36-1.37c-1.85-4.34-4.9-6.66-8.47-8.62-5.74-3.14-10.35-5.67-13.86-3.56Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.78,250.05c3.12-2,3.19-2.53,22.4-13.18l-.09,0c5.17-3.14,10-18.07,13.56-29.42,3.64-11.53,9.69-8.19,18.28-3.49,5.29,2.9,9.42,6.6,10.25,16.43s-1,34.2-4.34,37.15c-3.66,4-18.34,11.56-24.2,13.87-9.3,3.65-16.89-2-22.55-4.78a130.84,130.84,0,0,1-15-8.88C230.87,255.44,231.17,253.05,235.78,250.05Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.09,236.9h0Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.93,204c-8.59-4.7-14.64-8-18.28,3.49-3.58,11.35-8.4,26.29-13.57,29.43,0,0,8.87,0,21.72,6.93,13.35,7.21,15.39,14.27,16,13.76,3.37-2.8,5.2-27.35,4.37-37.18S295.22,206.89,289.93,204Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.71,211.58a14.27,14.27,0,0,0-3.23-2.38c-.83-.48-1.79-.77-2.66-1.2a15.84,15.84,0,0,1-3.66-2.4,6.73,6.73,0,0,1-1.35-1.52,12.06,12.06,0,0,1-.94-2,6.72,6.72,0,0,1-.45-2,3.53,3.53,0,0,1,.46-2,1.75,1.75,0,0,1,.89-.79,1.72,1.72,0,0,1,1.26.11,6,6,0,0,1,1.09.71,24.6,24.6,0,0,0,4.74,2.75,2.3,2.3,0,0,0,1.69.26,3.68,3.68,0,0,0-.46-1.39,6.25,6.25,0,0,1-.6-1.35,1.8,1.8,0,0,1,.17-1.42.68.68,0,0,1,.72-.32,1,1,0,0,1,.3.23c.5.52,1,1,1.5,1.55a10.06,10.06,0,0,1,1.15,1.57c.5.76.86,1.5,1.28,2.29a17.5,17.5,0,0,0,3.49,4.14c1.55,1.49,7.44,7.33,8.93,8.64,0,0,8.66-13.85,11-17.44,4.15-6.48,11.86-5.05,11.86-5.05l-2.31,9.6s-13.91,20-16.26,22.72a4.5,4.5,0,0,1-6.82.22,61.27,61.27,0,0,1-4.13-4.69c-2-2.38-4-4.77-6-7.11C234.77,212.72,234.25,212.14,233.71,211.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,192.3s-6.35-1-9.5,1.67c-2.93,2.54-3.91,4-7.81,10.67-3.57,6.09-6.09,9.57-6.09,9.57s2.57,6.42,7.77,6.29l8.64-11.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72,212.58a30.54,30.54,0,0,1-.37,9.74c-1.06,4.36-2.26,7.93-2.26,7.93a9.8,9.8,0,0,0,8.06,3c5.59-.52,4.5-13.78,1.46-17.17A10.47,10.47,0,0,0,259.72,212.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,316.84l-.69-.15c.1-2.2.36-4.21-.12-5.28l1.18-2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,306.93c-.26,1.5-1.22,3-1.48,6a25.06,25.06,0,0,0-.17,3.81l-.74.14.37-8.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,317.81a2,2,0,0,0,.41,1.13c.36.31,1.5,1.37,5.39,1.4s5.31-.84,6.72-2,2-4.27,2.26-5.75a11.08,11.08,0,0,1,3.1-5.7,2.58,2.58,0,0,0,.21-1.49,4.89,4.89,0,0,0-4.81,3.06c-1.62,3.45-3,7.5-6.18,8.28A49.92,49.92,0,0,1,240,317.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21,314.57c-1.25.94-2.18,1.34-2.14,2.29s1,1.45,1.8,1.75a13.36,13.36,0,0,0,6,.39c2-.22,4.12-1,5-2.74a7.77,7.77,0,0,0,.57-1.64,24.26,24.26,0,0,1,1.82-5.43,12.53,12.53,0,0,1,1.2-2.07,5.38,5.38,0,0,0,1.37-2.33,5.55,5.55,0,0,0-1.06-3l0,0a4.57,4.57,0,0,1-.69-3.54l.56-5.46-8.74,1.48s.47,4.81.47,6.05a21.28,21.28,0,0,1-.8,5.43,27.62,27.62,0,0,1-2.62,6.06,5.92,5.92,0,0,1-1,1.34A16.69,16.69,0,0,1,242.21,314.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.92,303.21c-.48-1-1.2-1.65-1.67-2.52a9.35,9.35,0,0,0-1.16,2.29c-.29.76-1.17,4.52-2.3,7.48a5.75,5.75,0,0,1-3.78,3.86,6.58,6.58,0,0,1-3.21.15h0c-2-.41-1.43-1.82-1.43-1.82a26.09,26.09,0,0,1-4,2.9,1.64,1.64,0,0,0-.31,2.27c.53.52,2.36,1.82,7.22,1.44,4.31-.33,5.44-2.24,5.9-3.1a20.35,20.35,0,0,0,1.15-3.95,12.76,12.76,0,0,1,1.78-4.15c.11-.16.21-.31.31-.43h0c.32-.4.69-.84,1.11-1.28s.56-.5.67-.84A3.23,3.23,0,0,0,257.92,303.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,309.51l-.68-.2c.26-2.19.67-4.17.27-5.28l1.37-2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.61,299.81c-.37,1.47-1.44,2.89-1.92,5.83a24.6,24.6,0,0,0-.45,3.78l-.75.09,1-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,309.33a2,2,0,0,0,.33,1.16c.33.34,1.4,1.43,5.27,1.74s5.36-.39,6.84-1.4,2.27-4.11,2.68-5.57a11,11,0,0,1,3.52-5.45,2.61,2.61,0,0,0,.32-1.48,4.89,4.89,0,0,0-5,2.7c-1.87,3.32-3.52,7.26-6.77,7.8A50.21,50.21,0,0,1,219,309.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.39,306.26c-1.32.85-2.27,1.17-2.3,2.13s.91,1.52,1.67,1.87a13.25,13.25,0,0,0,5.91.83c2-.07,4.18-.66,5.24-2.35a7.5,7.5,0,0,0,.69-1.59,24.1,24.1,0,0,1,2.22-5.29,12.05,12.05,0,0,1,1.35-2,5.42,5.42,0,0,0,1.53-2.23,5.53,5.53,0,0,0-.83-3.11v0c-.67-1.4-.87-1.95-.52-4.24l1-4.76-8.36.79s-.31,3.29-.39,5.76a17.65,17.65,0,0,1-1.2,5.71,27.81,27.81,0,0,1-3,5.85,6,6,0,0,1-1.08,1.27A16.68,16.68,0,0,1,221.39,306.26Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,295.85a24.32,24.32,0,0,0-1.4-2.33,8.6,8.6,0,0,0-1.33,2c-.49.93-1.49,4.58-2.84,7.46a5.8,5.8,0,0,1-4.05,3.57,6.5,6.5,0,0,1-3.22-.1h0c-2-.56-1.28-1.93-1.28-1.93a25.53,25.53,0,0,1-4.23,2.6,1.63,1.63,0,0,0-.48,2.24c.49.56,2.22,2,7.09,2,4.32,0,5.59-1.83,6.12-2.66a20.91,20.91,0,0,0,1.44-3.85,13,13,0,0,1,2.08-4l.34-.4h0c.35-.37.75-.79,1.2-1.2s.6-.45.74-.78A3.63,3.63,0,0,0,237.82,295.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,249.54c3.05-3.63,9.52-6.66,14.94-9.12s9.49-4.93,15.5-7.37c8.19,3,20.92,0,29.34-3.57,2.09,2.81,4.47,13.68,3.7,18.51-.75,4.66-2.4,10.18-13.36,14.62-6.53,2.65-20.07,8-20.07,8S260,274,259,281.05s-2.42,14.7-2.42,14.7a9.92,9.92,0,0,1-8.5.32s-2.53-20.58-3.16-27.18c-.33-3.45.25-5.77,1.15-6.78a31.78,31.78,0,0,1,6.64-5.46l-11.42,3.28s1.54,4.78-.29,12.46c-1.65,6.89-4.2,15.78-4.2,15.78s-2.71,2-8.26-.3c0,0-.31-21.15-.47-27.78C227.91,254.17,227.94,251.19,229.32,249.54Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,249.54c3.05-3.63,9.52-6.66,14.94-9.12s9.49-4.93,15.5-7.37c8.19,3,20.92,0,29.34-3.57,2.09,2.81,4.47,13.68,3.7,18.51-.75,4.66-2.4,10.18-13.36,14.62-6.53,2.65-20.07,8-20.07,8S260,274,259,281.05s-2.42,14.7-2.42,14.7a9.92,9.92,0,0,1-8.5.32s-2.53-20.58-3.16-27.18c-.33-3.45.25-5.77,1.15-6.78a31.78,31.78,0,0,1,6.64-5.46l-11.42,3.28s1.54,4.78-.29,12.46c-1.65,6.89-4.2,15.78-4.2,15.78s-2.71,2-8.26-.3c0,0-.31-21.15-.47-27.78C227.91,254.17,227.94,251.19,229.32,249.54Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,193s9.21,1.49,10.3,2c-9,5.71-2.56,19.62-2.56,19.62l-1.87,9.83c1.21,3.73,4.2,9.37,5.75,15-12.39,6.69-32.6,3.16-33.88-6.18.81-3.62,1.32-8.78,1.83-11.44,0-2,.25-4.23.17-7.46a9.29,9.29,0,0,1-1.47-10.87c3.76-6.68,9.91-11.38,11.8-11.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.57,165.51c-3.07,1.21-4.68,4.82-5.08,13.59-.33,7.44,1.95,9.43,3.12,10s3.53.45,5.82.23l-.17,3.07s-4.27,4.31-4.21,6.37,5.1,3.32,8.17,1.52,5.86-6.53,5.86-6.53l.58-9.23s1.24,1.39,3.64-.43c2-1.51,2.79-4.21,1.43-5.79a3.26,3.26,0,0,0-5.24.68,12.89,12.89,0,0,0-4.41-8.55C274,167,271.9,165.56,268.57,165.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,193.47s4,.36,5.3.57c1.87.29,5.95,6.69,3.78,13.92-2.34,7.78-4.49,15.19-4.31,16.88s4,11.89,4,11.89c-1.07,1.53-3.33,2.4-5.28,2.67L285,231l.5,9a42.55,42.55,0,0,1-9.76.4S276.78,211.57,283.94,193.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.49,194.65c5.26.38,7.81,2.19,9.32,8.29,1.36,5.49,4.22,18.91,4.76,22.47.49,3.25.67,4.48-1,7.33-1.39,2.33-11.47,15.28-12.69,17.22a51.23,51.23,0,0,1-4.62,6.13,12.18,12.18,0,0,1-6.77,3.84c-2.82.35-6-1.32-5.87-2.95s4.94-3.53,7.18-6.56a15.37,15.37,0,0,1-2.5.82c-1.17.25-2.35-.07-2.6-.75s.9-.85,2-1.63c.68-.47,1.93-1.56,3.44-2.46,1-.6,2.45-.92,3.25-1.64a46.33,46.33,0,0,0,4.61-6.87c2.26-4,5.8-9.87,5.8-9.87L290.64,210S288.21,198.31,290.49,194.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,194a16.44,16.44,0,0,1,6,1.11,8.61,8.61,0,0,1,4,4.5c.71,1.72,5.65,25.55,5.65,25.55s-1.3,1.47-4.87,2.11a12.74,12.74,0,0,1-5.89,0l-4.38-18.7S286.49,199.94,289.24,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.16,161.66c3.91-2.06,6-2.43,9.57-2.18,3.35.22,7.46,1.65,9.67,4.16a16.47,16.47,0,0,1,3.89,7,15.86,15.86,0,0,1-.59,8.68c-1.77,5.59-9.31,9.61-9.46,12l.42-6.74s1.24,1.38,3.64-.44c2-1.5,2.79-4.21,1.43-5.79a3.26,3.26,0,0,0-5.24.68l-.11,1.91a2,2,0,0,1-1.89-2.12l.18-3.11c-3.39-.43-10-2.45-9.61-9.83,0,0-.89,4.34,1.26,7.59,0,0-4.93-.82-4.71-5.48,0,0-.66,5.44-3.68,5.84a4.42,4.42,0,0,1-1.54-1.86C260.81,168.17,262.35,161.27,269.16,161.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,192.88h0a7.73,7.73,0,0,1-7.74-7.73V170.39h0a7.75,7.75,0,0,1,7.74,7.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,176.83a1.06,1.06,0,0,0,.91,1.2,1.09,1.09,0,1,0-.91-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,182.82l-3.81.94a1.94,1.94,0,0,0,2.33,1.5A2.07,2.07,0,0,0,274,182.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,184.11a1.58,1.58,0,0,0-1.41.88,1.82,1.82,0,0,0,1.48.27,2,2,0,0,0,1.05-.68A1.55,1.55,0,0,0,272.46,184.11Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.78,174.05l2.35,1.34a1.34,1.34,0,0,0-.46-1.86A1.43,1.43,0,0,0,273.78,174.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,173.47l2.51-1a1.34,1.34,0,0,0-1.73-.8A1.42,1.42,0,0,0,264.8,173.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.8 175.88 268.8 181.64 266.01 180.45 269.8 175.88",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.43,189.37c2.4-.15,7.41-1.23,8.31-3.12a5.07,5.07,0,0,1-1.89,2.36c-1.56,1.16-6.5,2.21-6.5,2.21Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,175.61a1.05,1.05,0,1,0,2.09.24,1.06,1.06,0,0,0-.91-1.2A1.08,1.08,0,0,0,264.72,175.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,256.65s8.64-5.5,12.24-8.14a20.3,20.3,0,0,1-4.32-5.08,10.12,10.12,0,0,0,1.75,5l-9,6.73-12.14,4.81Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,93.55c.41.42.83.84,1.26,1.25.58.55,1.76,1.43,2.34,2,.17.17.86.61.92.81a12.88,12.88,0,0,1-.68-2.94,1.82,1.82,0,0,1,1.42-2c.39,0,.42.94,1.23,2.31,1,1.75,2.4,2.66,3,4.78a3.9,3.9,0,0,0,2,2.15l16.26,8.07s11.9-4.41,18.06-6.82c7.16-2.81,15.36-5.48,16.73-4l-13.68,12.36s-10.41,5.64-18.51,8.87c-2.73,1.09-4.24.7-6.45-.79a147.59,147.59,0,0,1-13.86-9.16,94.68,94.68,0,0,0-8.85-5.72c-2.37-1.32-5.12-3.1-6.23-5.7a5.48,5.48,0,0,1,0-4.5,5.65,5.65,0,0,0,.79-1.78,10.84,10.84,0,0,0-.06-1.13,1.2,1.2,0,0,1,.4-1,1,1,0,0,1,1.08,0,3.32,3.32,0,0,1,.82.77Q102,92.47,103,93.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,98.45c-6.14-.91-9.22,1-13.43,2.72-5,2.07-21.11,8.32-21.11,8.32l-10.39-4.9s-2.39,5.4-5,7.59c0,0,9.34,6.62,11.93,8.23s2.75,1.53,6.83.19,22.51-6,22.51-6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.71,247.71a8,8,0,0,1-7.1.21L183.89,234l8.44.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,240.12c-1.7,4-5,3-8.8.59l.23-14.06,8.93-.27Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.37,261.4a3.3,3.3,0,0,0,.16,2.16c.29.43,1.95,1.75,4.87,1.88a11.8,11.8,0,0,0,6.86-1.42,4.82,4.82,0,0,0,2.47-3.85c.11-1.59-.12-3.11.6-4.36s1.74-2.45,2-3.07a6.25,6.25,0,0,0-.08-3.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,247.33a8,8,0,0,1-.29,1.78,16.5,16.5,0,0,1-1.6,3.53,15.74,15.74,0,0,1-1.11,1.68c-.82,1-1.84,1.88-2.7,2.86a5.72,5.72,0,0,0-1.62,3.47c-.05,2.19,2.34,2.86,4.17,3.13a13.47,13.47,0,0,0,5.92-.47,5.46,5.46,0,0,0,3.87-4.47c.08-.61,0-1.23.08-1.84a8.52,8.52,0,0,1,1.58-3.87,11.62,11.62,0,0,0,1.24-2.12c.53-1.37,0-2.88-.37-4.21-.35-1.15-.75-2.46-1.15-2.34a1.49,1.49,0,0,1-.08.7,3.14,3.14,0,0,0-.3.7,4.88,4.88,0,0,1-.31.91,2.38,2.38,0,0,1-.93,1.1c-.05-.83-.11-1.65-.16-2.47a1.11,1.11,0,0,0-.21-.72,1.16,1.16,0,0,0-.71-.28,15.05,15.05,0,0,0-4.68-.25.83.83,0,0,0-.62.29.89.89,0,0,0-.08.56C184.58,245.8,184.63,246.57,184.6,247.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,253.11c.79-.63,2.61-.7,3.61-.62a6.12,6.12,0,0,1,2.86.91.64.64,0,0,0,.83-.09h0a.61.61,0,0,0-.08-.93,6.27,6.27,0,0,0-3.23-1.08c-2.45-.1-3.16.34-3.16.34S182.17,252.39,182.43,253.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,255.4c1-.63,3-.6,4-.53a5.67,5.67,0,0,1,2.79,1,.65.65,0,0,0,.83-.09h0a.62.62,0,0,0-.09-.93,6.36,6.36,0,0,0-3.29-1.18c-2.46-.1-3.08.42-3.08.42A2,2,0,0,0,180.62,255.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,248.92a6.16,6.16,0,0,0-3.07.35c-.43.26-.69.95-.41,1.11a5.78,5.78,0,0,1,2.72-.45,8,8,0,0,1,2.67.65,7.09,7.09,0,0,1,.69.32.58.58,0,0,0,.8-.27h0a.56.56,0,0,0-.23-.7A8,8,0,0,0,187.33,248.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.51,249.8a2.66,2.66,0,0,0,.17,1.94c.29.56,3.31,2.15,7.3,1.76a16.77,16.77,0,0,0,8.2-3.14,9.63,9.63,0,0,1,5.06-1.47c2-.17,4.56-1.24,5-2.18a4.45,4.45,0,0,0-.14-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,237l-1.05-.36a.93.93,0,0,0-.59-.05.87.87,0,0,0-.41.68,9.89,9.89,0,0,1-.38,1.75,4.53,4.53,0,0,1-1.09,1.22,18.31,18.31,0,0,1-3.15,2.16c-1.28.74-2.55,1.33-3.88,2s-3.18,1.1-4.24,1.86a2.89,2.89,0,0,0,.16,4.77,14.19,14.19,0,0,0,9.9.39c2.3-.73,4.8-3.29,7.84-3.62,1.94-.21,5.59-.86,6.79-2.37.44-.67-.23-2.72-.79-4.49-.61-1.93-.91-5-1.55-4.79,0,.65-.58,1.05-.9,1.6a10.8,10.8,0,0,0-.65,1.57,2.82,2.82,0,0,1-1,1.36,1.27,1.27,0,0,1-1.57,0c-.59-.57-.28-1.62-.72-2.31a2.46,2.46,0,0,0-1.39-.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,241.3a1.82,1.82,0,0,1,1.41-1,5.2,5.2,0,0,1,3.44,1.18.72.72,0,0,1-.07,1.2h0a.69.69,0,0,1-.82-.07A5.59,5.59,0,0,0,154.35,241.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67,242.91a2.07,2.07,0,0,1,1.67-.92,6.49,6.49,0,0,1,3.77,1.28.71.71,0,0,1-.07,1.16h0a.68.68,0,0,1-.79-.07A5.58,5.58,0,0,0,151.67,242.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69,244.38a2.33,2.33,0,0,1,1.74-.84,6.24,6.24,0,0,1,3.61,1.3A.71.71,0,0,1,154,246h0a.69.69,0,0,1-.8-.07A5.31,5.31,0,0,0,148.69,244.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,145.75c1,15.28,2.51,49,2.51,49,.22,1.9.92,6.46,1.26,13.3.51,9.93-.28,31.85-.28,31.85a10.7,10.7,0,0,1-8.48.67s-5.64-31.26-7.45-41c-1.59-8.56-4.68-24.7-4.68-24.7l-1.45,20.87a69,69,0,0,1-.34,12.62c-.57,4.53-3.29,24.19-3.29,24.19a18.09,18.09,0,0,1-9.59.08s-.87-32.09-1.08-36.27c-.23-4.75-1.23-53.65-1.23-53.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,174.84l-2.64-12.46s-6.28-.37-9.85-3.76c0,0,.72,3.41,8.66,5.23l2.64,12.61.26,11.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,100.3c3,.53,3.2,2,3.85,5a24.23,24.23,0,0,1,.77,7.32l-2.24,17.61.77,20.27c-4.83,5.26-24.15,6.94-34.7-.76,0,0,.11-33.31.6-38.65.85-9.34,5.08-12.66,11.3-12.64l10.63.9Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.31,76.69a9.44,9.44,0,1,1-9.4-9.47A9.42,9.42,0,0,1,175.31,76.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27,78.53l2-5.41a3.57,3.57,0,0,1,2.93,1c1.25,1.29.54,5.32-1,9.26,0,0-1.56,7.18-2.18,8.36a3.22,3.22,0,0,1-1.88,1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,83.74c.58.35,1.4-.76,2.12-1.5a2.51,2.51,0,0,1,4.19.69c1.18,2.5-1,5.78-2.87,6.35-3.16,1-3.63-1-3.63-1L178,99.61a10.15,10.15,0,0,1-7.68,5.79c-5.59.74-4.42-3.87-2.58-6.12l0-3.47a19.76,19.76,0,0,1-4.25.21c-2.32-.37-3.77-2.21-4.47-4.72-1.11-4-1.53-7.3-.55-15.22,1.08-8.7,11.2-8.75,16.65-5.29S178.42,83.74,178.42,83.74Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36,84.5c.91-.26,1.58-1.72,2.18-2.26,1-.9-.26-9.12-.26-9.12a3.87,3.87,0,0,0-.94-4.15c-1.36-1.51-3.64-1.68-7.54-2.31-1.92-.31-4.18-.46-6.08-.81A19,19,0,0,1,160.06,64a1.71,1.71,0,0,0-1.08-.28,1,1,0,0,0-.68.57,1.81,1.81,0,0,0-.16.89,3.32,3.32,0,0,0,.16,1c.06.19.43.74.35.9-.19.39-1.69-.27-2-.36a.33.33,0,0,0-.22,0c-.06,0-.09.08-.12.14a3.63,3.63,0,0,0,.17,3.15,10.69,10.69,0,0,0,5.36,4.56,14.83,14.83,0,0,0,7.3,1,13.88,13.88,0,0,0,3.12-.73,8.81,8.81,0,0,0,.68,1.07,5.33,5.33,0,0,0,1,.89,4.29,4.29,0,0,0,1.21.56c.45.12.87.06,1.12.54a2.25,2.25,0,0,1,.18,1l.09,3a5.1,5.1,0,0,0,.2,1.51,1.67,1.67,0,0,0,1,1.07A1,1,0,0,0,178.36,84.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71,95.81s5.18-1,7-2a6,6,0,0,0,2.51-2.47,8.08,8.08,0,0,1-1.43,2.92c-1.33,1.69-8.08,2.91-8.08,2.91Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,82.17a1,1,0,1,0,1-1.07A1.05,1.05,0,0,0,168.48,82.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,79l2.3,1.49a1.44,1.44,0,0,0-.43-2A1.33,1.33,0,0,0,169.72,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,88.48l-3.65,1.57a2,2,0,0,0,2.68,1.06A1.94,1.94,0,0,0,170.21,88.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,80.11l2.19-1.33a1.23,1.23,0,0,0-1.72-.46A1.34,1.34,0,0,0,159,80.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,81.85a1,1,0,1,0,2.07,0,1,1,0,0,0-1-1.08A1.06,1.06,0,0,0,159.82,81.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.6 81.29 164.72 87.91 161.34 86.46 165.6 81.29",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,149.92v2.26a.69.69,0,0,1-.91.67,13.23,13.23,0,0,1-2.51-1,5.91,5.91,0,0,1-1.85-1.49l-.11-3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,146.9c1.27,2.06,5.38,3,5.38,3s-.09-1.48,0-9.61.4-23.2,2.17-30A36.39,36.39,0,0,1,166,99.87a2.11,2.11,0,0,1,1.64-1v-.4c-6.14-.1-7.4.52-10,3.78s-3.11,9.4-3.42,16.35C154,125.34,152,141.82,153.77,146.9Zm19.35-17.75c-.49,18.66.71,27.95.93,29.47,0,0,13.84-.52,17.19-5.06-.4-5.88-.92-16.42-1.28-23.08l2-22.78a7.37,7.37,0,0,0-4.25-7.33l-9.64-1.26c-.81,1.88-2.62,4.33-3.5,8C173.47,111.86,173.39,118.65,173.12,129.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,97.92a8,8,0,0,0-4.82,2.88,27.93,27.93,0,0,0-3.59,6.63,2.57,2.57,0,0,0,.53,2.49s-1.82,4.62-1.52,6.85a23.93,23.93,0,0,0,1.49,5s2.34-13.81,4.53-18c2.31-4.49,3.37-4.47,3.37-4.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,98c1.35.32,4.86,1.73,4.86,1.73s-3.16,7.33-4.27,9.22a4.83,4.83,0,0,1-2.74,2.28,30,30,0,0,1,.27,6.48,34.88,34.88,0,0,1-2.88,7.19c0-.21-1.32-8.75.76-16.78a26.7,26.7,0,0,1,4-9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.34 127.09 154.23 128.87 159.12 158.62 134.56 156.28 128.34 127.09",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.34 127.09 154.23 128.87 159.12 158.62 134.56 156.28 128.34 127.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42,146.35c-.16.59.24,1.44,1.42,2.44.94.81,1.56,2.22,3.18,2.61a10.9,10.9,0,0,0,5,.34l-.66-4.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.67,130.19s0-.41-.13-.92,1.49-.81,3.48-.68l3.82.24c2,.13,3.67.65,3.74,1.15l.13.92Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,126.91c-.05-.32.59-.52,1.42-.45l1.51.12s-.27-2,3.1-1.89S144.1,127,144.1,127l1.61.15c.89.08,1.67.39,1.75.7l.14.56-13.34-.91S134.22,127.23,134.18,126.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,127.6c1.22.06,1.73.12,1.84.9s.15,1.56.15,1.56l5.9.41s-.18-1.12-.23-1.57.18-.75,1.12-.69l.12-.38-9.26-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,130.31s-.06-.41-.13-.92,1.49-.81,3.48-.68l3.82.24c2,.13,3.66.65,3.73,1.15l.13.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.87,138.9c1.84.09,4.67.73,6.25,1a8,8,0,0,0,2.49.14,12,12,0,0,0,2-.39c2.26-1,20.33-8.43,20.33-8.43l-3.07-17.78s-.72-11.42,4.26-12.62c3.84,1.74,5.06,5.12,6.82,12.64,2,8.6,3.57,18.64,2.77,21.36-.54,1.88-.65,3.89-4.84,5.51-4.43,1.72-9.37,2.88-24,7.06a72.36,72.36,0,0,1-8.38,2.39c-7.44,1.17-10.41-.18-11.89-3.06-.43-.83-.49-1.76-.88-2.61a6,6,0,0,1-.61-1.43,1.09,1.09,0,0,1,.62-1.27,1.71,1.71,0,0,1,.71,0c1.18.23,2.35.46,3.53.62a23.33,23.33,0,0,0,4.09.15.78.78,0,0,0,.21,0c.2-.09.15-.17,0-.24",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,100.37c3.46.43,5.73,3.33,6.46,6.75,1.15,5.37,1.69,8.44,3,15.24,1.2,6.18,1.67,13.22.9,15.15s-4.71,3.2-7.19,3.93c-3.7,1.1-14.7,3.83-14.7,3.83.08-2.58-1.39-7-3.65-8.53l13.88-6.17-3.56-15.77S181.33,103.32,187.72,100.37Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 369.49 100.48 368.4 100.48 291.77 102.37 292.86 102.37 369.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 369.49 104.26 368.4 104.26 291.77 102.37 292.86 102.37 369.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.51 321.91 150.62 320.82 150.62 264.96 152.51 266.05 152.51 321.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.51 321.91 154.4 320.78 154.4 264.93 152.51 266.05 152.51 321.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.4 264.96 102.37 295.03 102.37 292.85 154.4 262.78 154.4 264.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.59 311.89 201.71 310.84 201.03 235.85 202.92 236.9 203.59 311.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.59 311.89 205.48 310.84 204.81 235.86 202.92 236.9 203.59 311.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.81 235.85 152.5 266.1 152.5 263.92 204.81 233.71 204.81 235.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.03 257.42 152.61 286.57 152.6 284.47 203.03 255.32 203.03 257.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "152.51 282.42 104.26 310.21 104.26 312.38 152.51 284.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.4 283.44 202.92 255.38 202.92 253.24 154.4 281.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.61 286.57 102.37 315.58 102.37 313.47 152.6 284.47 152.61 286.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.79 328.4 266.86 394.11 266.86 387.78 152.79 321.91 152.79 328.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 299.19 154.68 329.38 154.68 323.05 102.37 292.86 102.37 299.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 464.4 264.98 463.31 264.98 386.69 266.86 387.79 266.86 464.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 464.4 268.75 463.31 268.75 386.7 266.86 387.79 266.86 464.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317 435.68 315.12 434.59 315.12 359.89 317 360.98 317 435.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317 435.68 318.89 434.56 318.89 359.85 317 360.98 317 435.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.89 363.95 266.86 394.11 266.86 387.78 318.89 357.71 318.89 363.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.41 406.53 365.53 405.49 365.53 330.78 367.41 331.83 367.41 406.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.41 406.53 369.3 405.49 369.3 330.79 367.41 331.83 367.41 406.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.3 334.85 317 364.91 317 358.84 369.3 328.64 369.3 334.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.52 352.35 317.1 381.5 317.1 379.4 367.52 350.25 367.52 352.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "317.01 377.35 268.75 405.14 268.75 407.31 317 379.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "318.89 378.37 367.42 350.31 367.42 348.17 318.89 376.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.1 381.5 266.86 410.51 266.86 408.39 317.1 379.4 317.1 381.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 387.79 369.3 328.64 202.92 232.63 100.48 291.77 266.86 387.79",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 387.79 369.3 328.64 202.92 232.63 100.48 291.77 266.86 387.79",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 464.4 266.86 463.4 264.98 462.31 264.98 463.31 266.86 464.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 464.4 266.86 463.4 268.75 462.31 268.75 463.31 266.86 464.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.01 435.68 317.01 434.67 315.12 433.58 315.12 434.59 317.01 435.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.01 435.68 317.01 434.67 318.89 433.58 318.89 434.59 317.01 435.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.41 406.53 367.41 405.53 365.53 404.44 365.53 405.44 367.41 406.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.41 406.53 367.41 405.53 369.3 404.44 369.3 405.44 367.41 406.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 369.49 102.37 368.49 100.48 367.4 100.48 368.4 102.37 369.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.37 369.49 102.37 368.49 104.26 367.4 104.26 368.4 102.37 369.49",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebooks--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.11,286.16,294.26,292l.23.36v.29a.4.4,0,0,1-.23.36l-14.69,8.49a.83.83,0,0,1-.39.09.79.79,0,0,1-.38-.09l-10.9-6.3v-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,301.33a.83.83,0,0,0,.39-.09l14.69-8.49a.4.4,0,0,0,.23-.36.41.41,0,0,0-.23-.36l-10.66-6.15-15.7,9.06,10.9,6.3A.79.79,0,0,0,279.18,301.33Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,285l10.54,6.09.11.15v1.13h0a.18.18,0,0,1-.11.15L279.45,301a.62.62,0,0,1-.53,0l-10.54-6.09v-1.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38,293.81l.14.08,1.71,1,.32.18,8.37,4.83a.55.55,0,0,0,.53,0l14.69-8.48a.16.16,0,0,0,0-.3L294,291l-10.4-6-15.09,8.71,0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,300v1.13a.6.6,0,0,0,.27-.06l14.69-8.49a.18.18,0,0,0,.11-.15v-1.13a.19.19,0,0,1-.11.15l-14.69,8.48A.5.5,0,0,1,279.18,300Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38,293.66l1.9,1.1.3.17,8.34,4.81a.55.55,0,0,0,.53,0l13.15-7.59.34-.19A3.36,3.36,0,0,0,294,291l0,0,0-.08a.24.24,0,0,0-.19-.27,4.65,4.65,0,0,1-1-.41h0l-9.27-5.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.35,293.53a.15.15,0,0,1,0,.28.53.53,0,0,1-.49,0c-.14-.08-.14-.2,0-.28A.53.53,0,0,1,270.35,293.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44,293.37a2.11,2.11,0,0,0,0,.25l.17-.1a.76.76,0,0,1,0-.15.66.66,0,0,1,.25-.6.34.34,0,0,1,.17,0,.58.58,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06l.18,0a2,2,0,0,0-.83-1.19.62.62,0,0,0-.65-.05A.83.83,0,0,0,268.44,293.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.47,293.71a.08.08,0,0,1,0,0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.82,292.68a.15.15,0,0,1,0,.28.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.28A.53.53,0,0,1,271.82,292.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.91,292.52a2.11,2.11,0,0,0,0,.25l.17-.1c0-.05,0-.1,0-.15a.66.66,0,0,1,.25-.6.35.35,0,0,1,.18-.05.64.64,0,0,1,.3.09,1.82,1.82,0,0,1,.73,1.06l.18,0a2,2,0,0,0-.82-1.19.64.64,0,0,0-.66-.05A.83.83,0,0,0,269.91,292.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,291.83c.14.07.14.2,0,.28a.53.53,0,0,1-.49,0c-.13-.08-.13-.21,0-.28A.53.53,0,0,1,273.29,291.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,291.67a2.29,2.29,0,0,0,0,.25l.17-.1v-.15a.68.68,0,0,1,.24-.6A.41.41,0,0,1,272,291a.64.64,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06l.18,0a2,2,0,0,0-.83-1.19.64.64,0,0,0-.66,0A.84.84,0,0,0,271.38,291.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.77,291c.13.07.13.2,0,.28a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28A.53.53,0,0,1,274.77,291Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,290.82a1.1,1.1,0,0,0,0,.25l.17-.1a.76.76,0,0,1,0-.15.66.66,0,0,1,.25-.6.34.34,0,0,1,.17-.05.61.61,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06l.18,0a2,2,0,0,0-.83-1.19.62.62,0,0,0-.65-.05A.82.82,0,0,0,272.86,290.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,290.13c.13.07.13.2,0,.28a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28A.53.53,0,0,1,276.24,290.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,290a2.29,2.29,0,0,0,0,.25l.17-.1a.76.76,0,0,1,0-.15.66.66,0,0,1,.25-.6.35.35,0,0,1,.18-.05.64.64,0,0,1,.3.09,1.87,1.87,0,0,1,.73,1.06.52.52,0,0,0,.18,0,2.08,2.08,0,0,0-.82-1.18.64.64,0,0,0-.66-.05A.82.82,0,0,0,274.33,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,289.28c.14.07.14.2,0,.28a.53.53,0,0,1-.49,0c-.13-.08-.13-.21,0-.28A.53.53,0,0,1,277.71,289.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8,289.12a2.29,2.29,0,0,0,0,.25l.17-.1s0-.1,0-.15a.66.66,0,0,1,.25-.6.37.37,0,0,1,.18,0,.64.64,0,0,1,.3.09,1.88,1.88,0,0,1,.74,1.06.57.57,0,0,0,.18,0,2,2,0,0,0-.83-1.18.64.64,0,0,0-.66-.05A.84.84,0,0,0,275.8,289.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,288.43c.14.07.14.2,0,.28a.51.51,0,0,1-.48,0c-.14-.08-.14-.21,0-.28A.51.51,0,0,1,279.18,288.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.28,288.27a2.18,2.18,0,0,0,0,.25l.18-.1a.76.76,0,0,1,0-.15.68.68,0,0,1,.24-.6.41.41,0,0,1,.18-.05.64.64,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06l.18,0a2,2,0,0,0-.83-1.18.64.64,0,0,0-.66-.05A.84.84,0,0,0,277.28,288.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.66,287.58c.13.07.13.2,0,.28a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28A.53.53,0,0,1,280.66,287.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.75,287.42a1.1,1.1,0,0,0,0,.25l.17-.1a.76.76,0,0,1,0-.15.66.66,0,0,1,.25-.6.34.34,0,0,1,.17-.05.58.58,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06.52.52,0,0,0,.18,0,2.07,2.07,0,0,0-.83-1.19.64.64,0,0,0-.65,0A.82.82,0,0,0,278.75,287.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,286.72a.16.16,0,0,1,0,.29.53.53,0,0,1-.49,0,.16.16,0,0,1,0-.29A.6.6,0,0,1,282.13,286.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.22,286.57a2.29,2.29,0,0,0,0,.25l.17-.1a.76.76,0,0,1,0-.15.66.66,0,0,1,.25-.6.35.35,0,0,1,.18-.05.64.64,0,0,1,.3.09,1.82,1.82,0,0,1,.73,1.06.52.52,0,0,0,.18,0,2.06,2.06,0,0,0-.82-1.19.66.66,0,0,0-.66,0A.82.82,0,0,0,280.22,286.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,285.87a.15.15,0,0,1,0,.29.53.53,0,0,1-.49,0,.16.16,0,0,1,0-.29A.6.6,0,0,1,283.6,285.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.69,285.72a2.29,2.29,0,0,0,0,.25l.17-.1v-.15a.68.68,0,0,1,.24-.6.41.41,0,0,1,.18-.05.64.64,0,0,1,.3.09,1.83,1.83,0,0,1,.74,1.06l.18,0a2.07,2.07,0,0,0-.83-1.19.66.66,0,0,0-.66,0A.84.84,0,0,0,281.69,285.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.66,298.37a.29.29,0,0,1-.16,0l-8.11-4.68a.32.32,0,0,1-.11-.42.31.31,0,0,1,.42-.12l8.11,4.69a.3.3,0,0,1,.11.42A.31.31,0,0,1,280.66,298.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.64,297.8a.32.32,0,0,1-.16,0l-8.1-4.68a.31.31,0,1,1,.31-.53l8.1,4.68a.31.31,0,0,1,.12.42A.31.31,0,0,1,281.64,297.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.62,297.24a.27.27,0,0,1-.15-.05l-8.11-4.68a.3.3,0,0,1-.11-.42.32.32,0,0,1,.42-.11l8.1,4.68a.31.31,0,0,1-.15.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,296.67a.28.28,0,0,1-.15,0L275.34,292a.3.3,0,0,1-.11-.42.31.31,0,0,1,.42-.12l8.11,4.68a.31.31,0,0,1-.16.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,296.1a.28.28,0,0,1-.15,0l-8.11-4.68a.32.32,0,0,1-.11-.42.3.3,0,0,1,.42-.11l8.11,4.68a.31.31,0,0,1-.16.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.57,295.54a.3.3,0,0,1-.16-.05l-8.11-4.68a.32.32,0,0,1-.11-.42.31.31,0,0,1,.42-.11l8.11,4.68a.31.31,0,0,1-.15.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,295a.32.32,0,0,1-.16,0l-8.1-4.68a.31.31,0,0,1,.3-.54l8.11,4.68a.31.31,0,0,1-.15.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.53,294.4a.26.26,0,0,1-.15,0l-8.11-4.68a.31.31,0,0,1,.31-.53l8.1,4.68a.31.31,0,0,1,.12.42A.31.31,0,0,1,287.53,294.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.51,293.83a.28.28,0,0,1-.15,0l-8.11-4.68a.3.3,0,0,1-.11-.42.31.31,0,0,1,.42-.11l8.11,4.68a.32.32,0,0,1,.11.42A.31.31,0,0,1,288.51,293.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,293.27a.42.42,0,0,1-.15,0l-8.11-4.68a.32.32,0,0,1-.11-.42.31.31,0,0,1,.42-.12l8.11,4.68a.31.31,0,0,1,.11.42A.32.32,0,0,1,289.49,293.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,292.7a.29.29,0,0,1-.16,0L282.21,288a.32.32,0,0,1-.11-.42.3.3,0,0,1,.42-.11l8.11,4.68a.3.3,0,0,1,.11.42A.29.29,0,0,1,290.48,292.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.46,292.13a.32.32,0,0,1-.16,0l-8.1-4.68a.31.31,0,0,1-.12-.42.3.3,0,0,1,.42-.11l8.11,4.68a.3.3,0,0,1,.11.42A.29.29,0,0,1,291.46,292.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.44,291.57a.37.37,0,0,1-.15,0l-8.11-4.69a.3.3,0,0,1-.11-.42.32.32,0,0,1,.42-.11l8.1,4.68a.31.31,0,0,1-.15.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66,298.94a.37.37,0,0,1-.15,0l-8.58-5a.31.31,0,0,1-.11-.43.32.32,0,0,1,.42-.11l8.57,5a.31.31,0,0,1-.15.58Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.57,292.79a1.31,1.31,0,0,0,.41-.43.36.36,0,0,1,.19,0c.23,0,0,.12,0,.21s0,.06,0,.05.57-.12.46.15a0,0,0,0,0,0,0c.05,0,.28.05.25.11s0,.05,0,.05a4.51,4.51,0,0,1,.52,0l.24,0c.05.07,0,.2-.06.25a0,0,0,0,0,0,.05c.09.05.16.1.1.19s0,.06,0,.06c.22.07.62-.12.69.15s0,.2.21.18c0,0,.07-.07,0-.07-.22,0-.06-.25-.18-.33s-.42.08-.55,0,0-.09-.06-.19-.07,0-.09,0,0,0,0,0,0,0,0-.06,0,0,0-.07c.05-.25-.35-.19-.51-.2a2.72,2.72,0,0,1-.3,0s0-.06,0-.07l-.24-.09s.05-.1,0-.15-.35-.06-.45,0h-.08a.07.07,0,0,0,.07-.07s0,0,0-.09-.08-.08-.15-.09a.39.39,0,0,0-.21,0,.47.47,0,0,0,0-.23c-.06-.24-.34-.06-.48,0s0,.08,0,.07.24-.11.32-.09,0,.22-.05.34l-.16.08a.78.78,0,0,0-.33.21C275.25,292.82,275.41,292.87,275.57,292.79Zm.09-.26.12-.07a.56.56,0,0,1-.21.22s-.17.07-.12,0A.41.41,0,0,1,275.66,292.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.06,294.74s0,0,0,0c.19.06.37-.17.44-.39.06,0,.22,0,.24.08l0,.11a0,0,0,0,0,0,0c.1,0,.43-.12.38.06,0,0,0,0,0,0s.28,0,.31.09-.12.12-.05.21.15,0,.21,0,.08,0,.12,0,0,0,0,.07,0,.05.05.06.07,0,.1,0,0,0,.07,0l.13,0s.18.08.17.05-.09.14,0,.22.34,0,.42,0,.06-.09,0-.09l-.2,0c-.17-.07-.12-.13-.09-.21a0,0,0,0,0,0-.05c-.12,0-.2-.1-.28-.1s-.12.05-.14.05-.07,0-.07-.13a0,0,0,0,0-.05,0c-.08,0-.28.18-.28,0,0,0,.08-.08.09-.12s0-.11-.11-.12-.11,0-.16,0c-.21,0,0,0-.11-.06s-.08-.06-.2-.06l-.13,0c-.11,0,0,0,0-.08s0-.09,0-.15-.09-.09-.19-.07l-.18.06c0-.16,0-.28-.17-.28s-.08.07,0,.08.11.14.08.26A.7.7,0,0,0,279.06,294.74Zm.19-.13a.51.51,0,0,1,.13-.14s0,0,0,0S279.21,294.72,279.25,294.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,295.69a1.27,1.27,0,0,0,.41-.42.55.55,0,0,1,.18,0c.24,0,0,.13,0,.22s0,.05,0,.05.57-.13.46.14c0,0,0,.05,0,.05s.28.05.25.1,0,.05,0,.05a4.51,4.51,0,0,1,.52,0l.24,0c.05.06,0,.2-.06.24a0,0,0,0,0,0,.06c.09,0,.16.09.1.19s0,.05,0,.06c.23.06.63-.12.69.14s0,.21.22.19c0,0,.07-.07,0-.07-.22,0-.06-.25-.18-.34s-.42.08-.55,0,0-.1-.06-.19-.08,0-.09,0l0,0s0,0,0-.06,0,0,0-.07c.05-.25-.35-.18-.51-.2a1.5,1.5,0,0,1-.3,0s0-.06,0-.07l-.24-.1s.05-.09,0-.14-.34-.06-.44-.06h-.08s.06,0,.07-.07,0-.05,0-.1-.08-.08-.15-.09a.93.93,0,0,0-.22,0,.37.37,0,0,0,0-.22c-.06-.25-.34-.07-.48,0s-.05.08,0,.07a1.07,1.07,0,0,1,.32-.1c.13,0,0,.22,0,.34l-.16.08a.8.8,0,0,0-.33.22C276.36,295.72,276.52,295.77,276.68,295.69Zm.09-.26.12-.06a.63.63,0,0,1-.21.22s-.17.06-.12,0A.42.42,0,0,1,276.77,295.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.63,293.88s0,0,0,0c.19.06.37-.17.44-.39.07,0,.22,0,.24.08l0,.11a0,0,0,0,0,0,0c.1,0,.44-.12.38.06a0,0,0,0,0,0,0c.08.06.27,0,.3.09s-.12.12,0,.21.15,0,.22,0,.07-.05.11,0,0,0,0,.06,0,.05.05.07h.1s0,0,.07,0l.13,0s.19.08.17.05-.09.14,0,.21.34,0,.42,0,.07-.08,0-.08l-.2,0c-.17-.08-.12-.13-.09-.21s0-.05,0-.05-.19-.11-.28-.11l-.14.06c-.13,0-.07,0-.07-.14s0,0-.05,0-.27.19-.28,0c0,0,.09-.07.09-.11s0-.11-.1-.13a.47.47,0,0,0-.17,0c-.21,0,0,0-.11-.06a.18.18,0,0,0-.19-.06.71.71,0,0,1-.14,0c-.11,0,0,0,0-.07s0-.09,0-.15-.09-.1-.19-.08l-.18.06c0-.15,0-.28-.17-.27s-.08.07,0,.08.11.14.08.26C273.81,293.58,273.64,293.73,273.63,293.88Zm.18-.14a.45.45,0,0,1,.14-.13l0,.05S273.77,293.85,273.81,293.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,289.48a1.42,1.42,0,0,0,.41-.43.35.35,0,0,1,.18,0c.24,0,0,.12,0,.21s0,.06,0,0,.57-.12.46.15a0,0,0,0,0,0,0c.05,0,.28.05.25.11s0,.05,0,.05a4.51,4.51,0,0,1,.52,0l.24,0c.05.07,0,.2-.06.25s0,0,0,.05.16.1.1.19,0,.06,0,.06c.23.07.63-.12.69.15s0,.2.22.18c0,0,.07-.07,0-.07-.22,0-.06-.25-.18-.33s-.42.07-.55,0,0-.09-.06-.19-.08,0-.09,0,0,0,0,0,0,0,0-.06,0,0,0-.07c.05-.25-.35-.19-.51-.2a2.72,2.72,0,0,1-.3,0s0-.06,0-.07l-.24-.09s.05-.1,0-.15-.34-.06-.44,0h-.08a.09.09,0,0,0,.07-.07s0,0,0-.09-.08-.09-.15-.09a.45.45,0,0,0-.22,0,.39.39,0,0,0,0-.23c-.06-.24-.34-.06-.48,0s-.05.08,0,.07.24-.11.32-.09,0,.22,0,.34l-.16.08a.78.78,0,0,0-.33.21C281.24,289.51,281.4,289.56,281.56,289.48Zm.09-.26.12-.07a.63.63,0,0,1-.21.22s-.17.07-.12,0A.41.41,0,0,1,281.65,289.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.05,291.43s0,0,0,0c.19.06.37-.17.43-.39.07,0,.23,0,.25.08l0,.11a0,0,0,0,0,0,0c.1,0,.43-.12.38.06,0,0,0,0,0,0s.28,0,.31.09-.12.12,0,.21.15,0,.21,0,.08,0,.12,0,0,.05,0,.07,0,.05.05.06.06,0,.1,0,0,0,.07,0l.13,0s.18.08.16.05-.08.14,0,.22.34,0,.41,0,.07-.09,0-.09l-.19,0c-.17-.07-.13-.13-.09-.21s0-.05,0-.05-.19-.1-.27-.1a1.09,1.09,0,0,0-.14.05c-.14,0-.07,0-.07-.13s0,0-.05,0-.28.18-.28,0c0,0,.08-.08.09-.12s0-.11-.11-.12-.11,0-.16,0c-.22,0,0,0-.11-.06s-.08-.06-.2-.06a.57.57,0,0,1-.13,0c-.12,0,0,0,0-.07s0-.09,0-.15-.09-.09-.19-.07a.54.54,0,0,0-.18.06c0-.16,0-.28-.17-.28s-.08.07,0,.08.11.14.08.26A.7.7,0,0,0,285.05,291.43Zm.19-.14a.51.51,0,0,1,.13-.13l0,0S285.2,291.41,285.24,291.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,292.38a1.27,1.27,0,0,0,.41-.42.55.55,0,0,1,.18,0c.24,0,0,.13,0,.22a0,0,0,0,0,.05.05c.17,0,.57-.13.46.14a0,0,0,0,0,0,.05c.05,0,.28.05.25.1a0,0,0,0,0,0,0,4.69,4.69,0,0,1,.53,0l.24,0c0,.06,0,.2-.06.24a0,0,0,0,0,0,.06c.09,0,.16.09.1.19a0,0,0,0,0,0,.06c.23.06.63-.13.69.14s0,.21.22.19c0,0,.07-.07,0-.08-.22,0-.06-.24-.18-.33s-.42.08-.56,0,0-.1-.05-.2-.08,0-.09,0l0,0a.22.22,0,0,0,0-.06s0,0,0-.07c0-.25-.35-.18-.52-.2a1.4,1.4,0,0,1-.29,0s0-.06,0-.07l-.24-.1s.05-.09,0-.14-.34-.06-.44-.06h-.08s.06,0,.07-.07,0-.05,0-.1-.09-.08-.15-.09a.6.6,0,0,0-.22,0,.37.37,0,0,0,0-.22c-.06-.25-.34-.07-.48,0s-.05.08,0,.07a1,1,0,0,1,.32-.1c.13,0,0,.22-.05.34l-.16.08a.74.74,0,0,0-.33.22C282.35,292.41,282.51,292.46,282.67,292.38Zm.08-.26.13-.06a.63.63,0,0,1-.21.22s-.17.06-.13,0A.54.54,0,0,1,282.75,292.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.61,290.57s0,0,0,0c.19.06.37-.17.44-.39.07,0,.22,0,.24.08a.66.66,0,0,0,0,.11,0,0,0,0,0,0,0c.1,0,.44-.12.38.06a.06.06,0,0,0,0,0c.09.06.28,0,.31.09s-.12.12,0,.21.15,0,.21,0,.08-.05.12,0,0,0,0,.06,0,.05.05.07h.1s0,0,.07,0l.13,0s.18.08.17.05-.09.14,0,.21.34,0,.42,0,.06-.08,0-.08l-.2,0c-.17-.08-.12-.13-.09-.21s0-.06,0-.05-.2-.11-.28-.11l-.14.06c-.13,0-.07-.05-.07-.14s0,0-.05,0-.27.19-.28,0c0,0,.08-.07.09-.11s0-.11-.11-.13a.45.45,0,0,0-.16,0c-.21,0,0,0-.11-.06a.18.18,0,0,0-.19-.06.71.71,0,0,1-.14,0c-.11,0,0,0,0-.07s0-.09,0-.15-.09-.1-.19-.08l-.18.06c0-.15,0-.28-.17-.27s-.08.07,0,.08.11.14.08.26C279.8,290.27,279.63,290.42,279.61,290.57Zm.19-.14a.51.51,0,0,1,.13-.13.08.08,0,0,1,0,.05S279.76,290.54,279.8,290.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.05,294.38a1.23,1.23,0,0,0,.42-.43.33.33,0,0,1,.18,0c.24,0,0,.13,0,.22s0,.05,0,.05.56-.13.45.14a0,0,0,0,0,0,.05c.05,0,.28.05.26.1a0,0,0,0,0,0,0,4.51,4.51,0,0,1,.52,0,.88.88,0,0,1,.24,0c.06.06,0,.2-.05.24a0,0,0,0,0,0,.06c.09,0,.16.09.1.19a0,0,0,0,0,0,.06c.22.06.62-.13.69.14s0,.21.22.19c0,0,.06-.08,0-.08-.21,0-.05-.24-.18-.33s-.42.08-.55,0,0-.09-.06-.19-.07,0-.09,0l0,0a.21.21,0,0,1,0-.06s0,0,0-.07c.05-.25-.35-.19-.51-.2a1.5,1.5,0,0,1-.3,0s0-.06,0-.07l-.24-.1s.05-.09,0-.14-.35-.06-.45-.06h-.08s.07,0,.07-.07,0-.06,0-.1-.08-.08-.15-.09a.52.52,0,0,0-.21,0,.36.36,0,0,0,0-.22c-.06-.25-.33-.07-.48,0s0,.08,0,.06a1.41,1.41,0,0,1,.32-.09c.13,0,0,.22,0,.34l-.16.08c-.12.06-.26.1-.33.22S281.89,294.46,282.05,294.38Zm.09-.26.12-.06a.5.5,0,0,1-.21.22s-.17.06-.12,0A.54.54,0,0,1,282.14,294.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.52,292.75s0,0,0,0c.19.06.37-.17.44-.39.07,0,.22,0,.25.08a1,1,0,0,1-.05.11,0,0,0,0,0,0,0c.11,0,.44-.12.38.06,0,0,0,0,0,0s.27,0,.3.09-.12.12-.05.21.15,0,.22,0,.07,0,.12,0,0,.05,0,.07,0,0,0,.06.07,0,.1,0,.05,0,.07,0a.5.5,0,0,1,.13,0s.19.08.17.05-.09.14,0,.22.34,0,.42,0,.07-.08,0-.08l-.2,0c-.17-.08-.12-.13-.09-.21s0-.05,0-.05-.19-.11-.28-.1-.12.05-.14.05-.07,0-.07-.14,0,0,0,0-.27.18-.28,0,.09-.08.09-.12,0-.11-.1-.13a.47.47,0,0,0-.17,0c-.21,0,0,0-.11-.06a.18.18,0,0,0-.19-.06.71.71,0,0,1-.14,0c-.11,0,0,0,0-.07s0-.09,0-.15-.09-.09-.18-.08a.89.89,0,0,0-.19.07c0-.16,0-.28-.17-.28s-.08.07,0,.08.1.14.07.26S279.53,292.61,279.52,292.75Zm.18-.14a.45.45,0,0,1,.14-.13l0,0S279.66,292.72,279.7,292.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,290.88a.49.49,0,0,1,0,.24s0,0,0,0,.44-.13.39,0a0,0,0,0,0,0,.05c.09.05.28-.05.3.09s-.11.12,0,.21.15,0,.21,0,.08-.06.12,0,0,0,0,.06,0,.05,0,.06.06,0,.1,0l.06,0a.32.32,0,0,1,.14,0s.18.09.16.05-.08.14,0,.22.34,0,.41,0,.07-.08,0-.08l-.2,0c-.17-.07-.13-.12-.1-.21a0,0,0,0,0,0-.05c-.11,0-.19-.1-.28-.1l-.13,0c-.14,0-.07,0-.08-.13s0,0,0,0-.28.19-.28,0c0,0,.08-.08.09-.12s0-.1-.11-.12a.5.5,0,0,0-.17,0c-.21,0,0,0-.1,0a.22.22,0,0,0-.2-.07.3.3,0,0,1-.13,0c-.12,0,0,0-.05-.08s.05-.09,0-.15-.16-.15-.19,0v.05S277.63,290.86,277.63,290.88Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M275.56,302c-.16.43-.62.69-1.38.8l-10.94-6.41-1.42-1.44a.11.11,0,0,1,.12-.18l2.61.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,294.62l-2.33-.45a.08.08,0,0,0-.07.12l1.59,1.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,294.29a.08.08,0,0,1,.07-.12l.46.09h0a.4.4,0,0,0-.19.37v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.32,301.06l-.19-.11-.23-.13-8.26-4.74a1.2,1.2,0,0,1,.81-1.45l8.26,4.73.44.25C272.86,299.47,272,300.9,272.32,301.06Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,300.64l-.42-.24c-.13-.07-.06-.38.09-.7s.58-.83.74-.74l.32.18.11.06c-.17-.08-.55.33-.74.75s-.22.6-.11.68h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,300.58c-.29-.15.54-1.59.83-1.44l.43.25c-.29-.16-1.13,1.28-.84,1.43Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.32,301.06l-.42-.24c-.29-.15.51-1.55.81-1.46h0l.42.24C272.86,299.47,272,300.9,272.32,301.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,294.21l.08,0,1.69.92,8.74,5s0,0,0,0c-.25.38-.43.87-.27,1l-.19-.11-.23-.13-8.26-4.74h0l-1.58-1.79A.08.08,0,0,1,262,294.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,302.08l-1.78-1c-.13-.07-.06-.37.09-.69s.57-.84.74-.76h0l1.79,1c.36.21,0,1-.37,1.32A.43.43,0,0,1,274.1,302.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,301.52a1.3,1.3,0,0,1,.73-.88.28.28,0,0,1,.26,0c.27.25,0,1-.42,1.28a.42.42,0,0,1-.46.12C274,302,273.93,301.8,274,301.52Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.17,268.08l20-11.53a1.13,1.13,0,0,1,1.15,0l34.66,20a.26.26,0,0,1,0,.45l-20.17,11.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.66,265.65v.45a1.85,1.85,0,0,0,.92,1.6l32.29,18.64a1.77,1.77,0,0,0,.92.25,1.83,1.83,0,0,0,.93-.25l17.6-10.13a1.86,1.86,0,0,0,.92-1.6V274h0a.22.22,0,0,1-.11.2l-19.33,11.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.66,265.65l19.14-11a1.08,1.08,0,0,1,1.1,0l33.22,19.18a.24.24,0,0,1,0,.42l-19.33,11.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.97 283.73 253.29 277.78 223.1 260.35 212.72 266.27 242.97 283.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.72 266.27 213.11 266.5 223.1 260.8 252.9 278.01 253.29 277.78 223.1 260.35 212.72 266.27",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.72 266.27 213.11 266.5 223.1 260.8 252.9 278.01 253.29 277.78 223.1 260.35 212.72 266.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.04 267.17 247.85 267.28 242.79 270.2 233.79 265 233.6 264.89 238.85 261.86 248.04 267.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.85 267.28 242.79 270.2 233.79 265 238.85 262.08 247.85 267.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,285.36v1.23a1.77,1.77,0,0,1-.92-.25L209.58,267.7a1.85,1.85,0,0,1-.92-1.6v-.45Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,285.36v1.23a1.77,1.77,0,0,1-.92-.25L209.58,267.7a1.85,1.85,0,0,1-.92-1.6v-.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27,285.63a2.18,2.18,0,0,1-1.88-.14l-32.15-18.56a2.19,2.19,0,0,1-1.06-1.53l-3.52-21a2.19,2.19,0,0,1,.61-1.91l33.41,19.29a1.6,1.6,0,0,1,.79,1.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,285.36l-.22.13-.3.14-3.8-22.71a1.6,1.6,0,0,0-.79-1.13L204.27,242.5a1.9,1.9,0,0,1,.45-.34l33.47,19.32a1.64,1.64,0,0,1,.79,1.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.16,262.21l.51-.29a1.49,1.49,0,0,1,.31.69l3.81,22.75-.22.13-.3.14-3.8-22.71A1.81,1.81,0,0,0,238.16,262.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.16,266.26a7.05,7.05,0,0,0-3.24-4.17c-1.55-.9-2.62-.49-2.38.92a7.08,7.08,0,0,0,3.24,4.17C223.33,268.07,224.4,267.66,224.16,266.26Z",
    style: {
      fill: "#BDDEF7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.13,353.49a1.71,1.71,0,0,0,.85-.22L246,339.39a1,1,0,0,0,.53-.82,1,1,0,0,0-.49-.85L226.2,325.09a1.77,1.77,0,0,0-.93-.25,1.72,1.72,0,0,0-.86.22l-7.16,4.13a1.32,1.32,0,0,0-.51,1.72l.3.56a.25.25,0,0,1-.09.31l-14.42,8.39a1,1,0,0,0-.53.82,1,1,0,0,0,.5.85l17.69,11.39A1.7,1.7,0,0,0,221.13,353.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,352.06l-18-10.43c-.35-.2-.35-.53,0-.74l24.7-14.05a1.41,1.41,0,0,1,1.28,0l17.85,10.3c.36.21.36.54,0,.74l-24.54,14.17A1.38,1.38,0,0,1,220.78,352.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.62,337.12l-20.27-12.88a1.36,1.36,0,0,0-1.27,0l-7.3,4.22a.79.79,0,0,0-.31,1l.3.58a.79.79,0,0,1-.3,1l-14.71,8.56a.42.42,0,0,0,0,.78l18,11.62a1.33,1.33,0,0,0,1.27,0l24.54-14.17A.41.41,0,0,0,246.62,337.12Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.89,346.08l22.44-12.95a1.18,1.18,0,0,1,1.15,0l27.46,15.81a.25.25,0,0,1,0,.44L293.3,362.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,345.7a.5.5,0,0,0,.25.38L292,360.24a.51.51,0,0,0,.48,0l22-11.13v-.49l-25-14.44-22,11.13A.5.5,0,0,0,267.2,345.7Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,359.81v.48a.66.66,0,0,1-.25-.05l-24.53-14.16a.42.42,0,0,1,0-.77c-.14.07-.14.2,0,.28L292,359.75A.51.51,0,0,0,292.23,359.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,348.62l-22,11.13a.55.55,0,0,1-.5,0l-24.53-14.16c-.14-.08-.14-.21,0-.28l22-11.13Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,348.62v.49l-22,11.13a.51.51,0,0,1-.25.05v-.48a.51.51,0,0,0,.25-.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.13 348.82 289.11 334.38 289.11 327.95 314.13 342.46 314.13 348.82",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.13 348.82 289.11 334.38 289.11 327.95 314.13 342.46 314.13 348.82",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.51,342.24a.66.66,0,0,0-.31.53v1.3a.69.69,0,0,0,.31.53l24.41,14.08a.66.66,0,0,0,.61,0l18.65-10.08v-2l-25-14.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.16,332.15l-18.65,10.09c-.17.09-.17.25,0,.35l24.41,14.09a.72.72,0,0,0,.61,0l18.65-10.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.8,346.75a.52.52,0,0,0,.21.07.62.62,0,0,0,.33,0l.1,0c.17-.09.15-.26,0-.37a.6.6,0,0,0-.29-.08.57.57,0,0,0-.35.05l0,0C308.59,346.51,308.62,346.65,308.8,346.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,356.74v2a.62.62,0,0,1-.31-.07L267.5,344.6a.68.68,0,0,1-.3-.53v-1.31a.68.68,0,0,1,.23-.47c-.09.09-.07.21.07.3l24.42,14.08A.53.53,0,0,0,292.23,356.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.07,344a1.24,1.24,0,0,0-1.27.07,4.35,4.35,0,0,0-1.72,2.56l.41.06A4,4,0,0,1,311,344.4a1.1,1.1,0,0,1,.53-.16.53.53,0,0,1,.31.09,1.56,1.56,0,0,1,.5,1.42,4.37,4.37,0,0,1-1.7,3.36,1,1,0,0,1-.63.15l-.45.26,0,0a1,1,0,0,0,.53.14,1.51,1.51,0,0,0,.73-.21,4.76,4.76,0,0,0,1.91-3.71A2,2,0,0,0,312.07,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,341.61a.5.5,0,0,0,.25.39L292,356.15a.51.51,0,0,0,.48,0l22-13.44v-.48l-25-14.45-22,13.45A.49.49,0,0,0,267.2,341.61Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,355.72v.49a.51.51,0,0,1-.25-.06L267.45,342a.5.5,0,0,1-.25-.39.52.52,0,0,1,.25-.39.15.15,0,0,0,0,.29L292,355.67A.51.51,0,0,0,292.23,355.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,342.23l-22,13.44a.65.65,0,0,1-.5,0l-24.53-14.16a.15.15,0,0,1,0-.29l22-13.44Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,342.23v.48l-22,13.44a.42.42,0,0,1-.25.06v-.49a.51.51,0,0,0,.25-.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.47 348.63 314.47 342.24 314.13 342.46 314.13 348.82 314.47 348.63",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.47 348.63 314.47 342.24 314.13 342.46 314.13 348.82 314.47 348.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,342.13a.4.4,0,0,0,.24-.33v-.49l-24.13-13.63a1.29,1.29,0,0,0-1.12,0L267,340.21l25,14.43Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,342.13a.4.4,0,0,0,.24-.33v-.49l-24.13-13.63a1.29,1.29,0,0,0-1.12,0L267,340.21l25,14.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,341.64a.34.34,0,0,0,0-.65L289.78,327.2a1.23,1.23,0,0,0-1.12,0L267,339.72l25,14.44Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,341.64a.34.34,0,0,0,0-.65L289.78,327.2a1.23,1.23,0,0,0-1.12,0L267,339.72l25,14.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,336.45,288,327.18a1.23,1.23,0,0,1,1.12,0l22,12.73,2.09-1.22v2.47l0,0c.07.15,0,.32-.19.44l-18.39,10.61-25-14.44v-2.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,338.92c.31-.18.31-.47,0-.64l-23.9-13.8a1.23,1.23,0,0,0-1.12,0l-18.4,10.62,25,14.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.65 349.54 294.65 352.24 269.62 337.8 269.62 335.1 294.65 349.54",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.35,348.48a.74.74,0,0,0,.21.07.53.53,0,0,0,.33,0,.17.17,0,0,0,.1,0c.17-.09.15-.26,0-.37a.75.75,0,0,0-.29-.09.65.65,0,0,0-.35.06s0,0,0,0S294.17,348.38,294.35,348.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.52,350.59a1.46,1.46,0,0,0,.28.94,1,1,0,0,0,.81.38h0a1.59,1.59,0,0,0,.78-.23l.14-.09-.31-.18c-.77.43-1.38.07-1.38-.82a3.06,3.06,0,0,1,1.39-2.4.91.91,0,0,1,1-.05.72.72,0,0,1,.29.41.53.53,0,0,0,.33,0,1.24,1.24,0,0,0-.23-.49,1,1,0,0,0-.81-.37,1.51,1.51,0,0,0-.78.23A3.37,3.37,0,0,0,291.52,350.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,348l21.59-10.55v.36a.64.64,0,0,1-.28.48l-21.31,10.2Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,348l21.59-10.55v.36a.64.64,0,0,1-.28.48l-21.31,10.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,337.81a.34.34,0,0,0,0-.64l-23.89-13.8a1.23,1.23,0,0,0-1.12,0L267,333.78l25,14.44Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 354.64 266.97 340.2 266.97 333.77 292 348.22 292 354.64",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 354.64 266.97 340.2 266.97 333.77 292 348.22 292 354.64",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06,350.52a1,1,0,0,0,.81-.38,1.54,1.54,0,0,0,.28-.94,3.41,3.41,0,0,0-1.55-2.69,1.62,1.62,0,0,0-.78-.23c-.66,0-1.1.53-1.1,1.32a3.42,3.42,0,0,0,1.56,2.69,1.62,1.62,0,0,0,.78.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.83,349.2c0,.89-.62,1.25-1.39.81a3.09,3.09,0,0,1-1.39-2.41c0-.89.62-1.25,1.39-.8A3.06,3.06,0,0,1,287.83,349.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,346v.48c0,1-.68,1.37-1.52.88l-10.85-6.26a3.39,3.39,0,0,1-1.53-2.64V338c0-1,.69-1.37,1.53-.88l10.85,6.26A3.38,3.38,0,0,1,282.78,346Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.33 354.45 292.33 348.06 292 348.22 292 354.64 292.33 354.45",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.33 354.45 292.33 348.06 292 348.22 292 354.64 292.33 354.45",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M273.51,282.39c2.36,1.3,2.36,3.42,0,4.73a9.79,9.79,0,0,1-8.55,0c-2.36-1.31-2.36-3.43,0-4.73A9.79,9.79,0,0,1,273.51,282.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,284.56c.67-.91,2.4-1.56,4.44-1.59h-.15C267.29,283,265.58,283.64,265,284.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.57,274.65a12.44,12.44,0,0,1,7.52.2c2,.83,2,2.09-.07,2.81a12.42,12.42,0,0,1-7.53-.19C263.4,276.64,263.43,275.38,265.57,274.65Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.57,274.65a12.44,12.44,0,0,1,7.52.2c2,.83,2,2.09-.07,2.81a12.42,12.42,0,0,1-7.53-.19C263.4,276.64,263.43,275.38,265.57,274.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M264,272.05l10.84.29-1.15,12.75h0c-.07.46-.51.91-1.35,1.24a9.56,9.56,0,0,1-6.5-.16c-.85-.38-1.29-.85-1.33-1.32h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.79,272.34l-.24,2.59a4.53,4.53,0,0,1-.91.46,13.21,13.21,0,0,1-8.64-.22l-.28-.14a5.36,5.36,0,0,1-.67-.4l-.1-2.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,272.41l.05-2,1.27,0a3.63,3.63,0,0,1,.56-.24,13.15,13.15,0,0,1,8.63.22c.2.09.37.18.53.27l1.22,0-.05,2h0c0,.64-.62,1.26-1.8,1.72a13.11,13.11,0,0,1-8.63-.23C263.83,273.7,263.24,273,263.25,272.41Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.25,272.41l.05-2,1.27,0a3.63,3.63,0,0,1,.56-.24,13.15,13.15,0,0,1,8.63.22c.2.09.37.18.53.27l1.22,0-.05,2h0c0,.64-.62,1.26-1.8,1.72a13.11,13.11,0,0,1-8.63-.23C263.83,273.7,263.24,273,263.25,272.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.17,268.75a13.15,13.15,0,0,1,8.63.22c2.32,1,2.28,2.6-.09,3.51a13.18,13.18,0,0,1-8.63-.22C262.68,271.23,262.72,269.65,265.17,268.75Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.44,270h0l.44-1.6,3.1.08a12.2,12.2,0,0,1,3.08.08l3,.07.35,1.62h0c.17.59-.3,1.19-1.45,1.61a11.28,11.28,0,0,1-7.12-.18C264.69,271.22,264.22,270.6,264.44,270Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.44,270h0l.44-1.6,3.1.08a12.2,12.2,0,0,1,3.08.08l3,.07.35,1.62h0c.17.59-.3,1.19-1.45,1.61a11.28,11.28,0,0,1-7.12-.18C264.69,271.22,264.22,270.6,264.44,270Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,267.42a11,11,0,0,1,6.54.17c1.76.71,1.73,1.8-.06,2.42a11,11,0,0,1-6.54-.17C264.36,269.12,264.39,268,266.24,267.42Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.47,268.61s0,.12.2.24a3.07,3.07,0,0,0,.74.4,9.64,9.64,0,0,0,3.07.54,9.09,9.09,0,0,0,3-.38,2.6,2.6,0,0,0,.74-.37c.15-.11.19-.2.19-.22s-.15-.34-.9-.64a9.15,9.15,0,0,0-3-.54,9.61,9.61,0,0,0-3.09.38C265.67,268.28,265.48,268.56,265.47,268.61Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.47,268.61s0,.12.2.24a3.07,3.07,0,0,0,.74.4,9.64,9.64,0,0,0,3.07.54,9.09,9.09,0,0,0,3-.38,2.6,2.6,0,0,0,.74-.37c.15-.11.19-.2.19-.22s-.15-.34-.9-.64a9.15,9.15,0,0,0-3-.54,9.61,9.61,0,0,0-3.09.38C265.67,268.28,265.48,268.56,265.47,268.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,268.85a3.07,3.07,0,0,0,.74.4,9.64,9.64,0,0,0,3.07.54,9.09,9.09,0,0,0,3-.38,2.6,2.6,0,0,0,.74-.37,2.84,2.84,0,0,0-.72-.4,9.15,9.15,0,0,0-3-.54,9.33,9.33,0,0,0-3.09.39A2.69,2.69,0,0,0,265.67,268.85Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M265.67,268.85a3.07,3.07,0,0,0,.74.4,9.64,9.64,0,0,0,3.07.54,9.09,9.09,0,0,0,3-.38,2.6,2.6,0,0,0,.74-.37,2.84,2.84,0,0,0-.72-.4,9.15,9.15,0,0,0-3-.54,9.33,9.33,0,0,0-3.09.39A2.69,2.69,0,0,0,265.67,268.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.51,268.94a1,1,0,0,0-.73-.16c-.13.07,0,.26.24.42a.93.93,0,0,0,.72.16C267.87,269.28,267.77,269.09,267.51,268.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274.16,281c0,.48-.51.95-1.48,1.29a11.69,11.69,0,0,1-7.09-.18c-1-.39-1.47-.88-1.46-1.36l-.19-4.7c0,.51.51,1,1.55,1.45a12.42,12.42,0,0,0,7.53.19c1-.36,1.55-.86,1.57-1.36Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,281.16a5.4,5.4,0,0,0,.44-.78,2.44,2.44,0,0,1,1.26-1.05.16.16,0,0,1,.19.08,1.84,1.84,0,0,1-2.35,2.25.06.06,0,0,1,0-.09A1.49,1.49,0,0,0,270.84,281.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.25,279.18a2.57,2.57,0,0,0-.79.45,2.65,2.65,0,0,0-.58.75,2.3,2.3,0,0,1-.72.92.16.16,0,0,1-.21,0,1.61,1.61,0,0,1,.42-2,1.65,1.65,0,0,1,1.9-.38A.15.15,0,0,1,272.25,279.18Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.26,344.11l-22.2,12.82a1.38,1.38,0,0,1-1.25,0l-16.35-9.44a.38.38,0,0,1,0-.72L241.67,334a1.38,1.38,0,0,1,1.25,0l16.34,9.44C259.61,343.58,259.61,343.91,259.26,344.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,343.16,237.06,356a1.38,1.38,0,0,1-1.25,0l-16.35-9.43a.38.38,0,0,1,0-.72L241.67,333a1.38,1.38,0,0,1,1.25,0l16.34,9.44C259.61,342.64,259.61,343,259.26,343.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.92,333l15.52,9-21.38,12.35a1.38,1.38,0,0,1-1.25,0l-15.52-9L241.67,333A1.38,1.38,0,0,1,242.92,333Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,340.9l-22.2,12.83a1.44,1.44,0,0,1-1.25,0l-16.35-9.44a.38.38,0,0,1,0-.72l22.21-12.82a1.38,1.38,0,0,1,1.25,0l16.34,9.43C259.61,340.38,259.61,340.7,259.26,340.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cup--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.69,315.8c2.77,1.17,2.79,3.11,0,4.33a14.23,14.23,0,0,1-10,.09c-2.76-1.17-2.78-3.11,0-4.33A14.31,14.31,0,0,1,238.69,315.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M239.9,315.88a3.43,3.43,0,0,0,1.86-.21c.75-.33,1.21-1.23,1.74-2.68.45-1.23,1.18-4.73.66-5.61-.79-1.35-2.48-1.15-3.87-1.11h-.48l0,1.7h.52c.78,0,2.09-.05,2.3.38.33.84-.64,5.33-1.33,5.81a3.42,3.42,0,0,1-2,0l-.6,1.48A5.26,5.26,0,0,0,239.9,315.88Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.9,315.88a3.43,3.43,0,0,0,1.86-.21c.75-.33,1.21-1.23,1.74-2.68.45-1.23,1.18-4.73.66-5.61-.79-1.35-2.48-1.15-3.87-1.11h-.48l0,1.7h.52c.78,0,2.09-.05,2.3.38.33.84-.64,5.33-1.33,5.81a3.42,3.42,0,0,1-2,0l-.6,1.48A5.26,5.26,0,0,0,239.9,315.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,304c-.17-.68-.85-1.33-2.05-1.84a14.31,14.31,0,0,0-10,.09c-1.19.53-1.86,1.2-2,1.87h0c-.43,4.47.41,9.62,2,12.47l0,.05,0,.05h0a3.45,3.45,0,0,0,1.31,1.21,8.38,8.38,0,0,0,7.57-.06,3.43,3.43,0,0,0,1.29-1.24h0a.05.05,0,0,1,0,0l0-.07c1.56-2.87,2.31-8,1.8-12.49Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.69,302.14c2.77,1.18,2.79,3.12,0,4.34a14.34,14.34,0,0,1-10,.09c-2.76-1.17-2.78-3.11,0-4.34A14.31,14.31,0,0,1,238.69,302.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.74,302.9c2.23.77,2.24,2,0,2.84a14.14,14.14,0,0,1-8,.07c-2.23-.76-2.24-2,0-2.83A14.05,14.05,0,0,1,237.74,302.9Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.74,302.9c2.23.77,2.24,2,0,2.84a14.14,14.14,0,0,1-8,.07c-2.23-.76-2.24-2,0-2.83A14.05,14.05,0,0,1,237.74,302.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M237.75,304.62a4,4,0,0,1,1.12.55,4.53,4.53,0,0,1-1.11.57,14.14,14.14,0,0,1-8,.07,4,4,0,0,1-1.12-.55,4.08,4.08,0,0,1,1.11-.57A14.05,14.05,0,0,1,237.75,304.62Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.29,294a.15.15,0,0,0,.08.21l20.13,11.63a.51.51,0,0,0,.25.05.4.4,0,0,0,.25-.05l28.1-16.23a.16.16,0,0,0,.09-.09.12.12,0,0,0,0-.14l0,0,0,0L149,277.73a.5.5,0,0,0-.5,0L120.37,294l0,0h0a.12.12,0,0,0-.07,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--List--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.15,288.21v.48a.53.53,0,0,1-.24.42L141,304.67a.51.51,0,0,1-.48,0l-19.32-11.15a.52.52,0,0,1-.24-.41v-.49a.52.52,0,0,1,.24-.41l27-15.57a.51.51,0,0,1,.48,0l19.31,11.15A.51.51,0,0,1,168.15,288.21Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,292.23c-.1.07-.09.18,0,.25l19.32,11.15a.44.44,0,0,0,.23.06v1a.45.45,0,0,1-.24-.06l-19.32-11.15a.52.52,0,0,1-.24-.41v-.49A.51.51,0,0,1,121.13,292.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,287.82h0l0,0h0a.52.52,0,0,1,.12.26v.54a.57.57,0,0,1-.24.42l-27,15.56a.5.5,0,0,1-.24.06v-1a.51.51,0,0,0,.25-.06l27-15.56a.28.28,0,0,0,.09-.1.16.16,0,0,0,0-.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,281c0-.18-.1-.36-.39-.53a1.82,1.82,0,0,0-.86-.23h-.08a14.76,14.76,0,0,0-2.2.45h0a5.08,5.08,0,0,1-1.89-.21h-.54a5.83,5.83,0,0,1-1.22,0c-.32,0-.56,0-.74,0h-.07a.86.86,0,0,0-.54.11l-1.08.62v.36l8.09,4.67,1.08-.62a.32.32,0,0,0,.18-.33v-.35a1.4,1.4,0,0,0-.09-.46,2,2,0,0,1-.06-.27,1.38,1.38,0,0,0,0-.26v-.36a.69.69,0,0,0,0-.13c-.06-.18-.31-.37-.39-.65l0-.09c.17-.39.78-.85.77-1.28C160.85,281.25,160.86,281,160.85,281Zm-1.66,1a2.07,2.07,0,0,1-.58.23,1.59,1.59,0,0,1-1.1-.09.53.53,0,0,1-.2-.19,1.12,1.12,0,0,1,.44-.42,2,2,0,0,1,1.48-.22l.2.08a.53.53,0,0,1,.2.19A1,1,0,0,1,159.19,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,280.46l-1.08.62,8.09,4.67,1.08-.62c.14-.08.28-.19.09-.78s0-.75,0-1-.6-.55-.36-1.1,1.36-1.24.38-1.81a1.82,1.82,0,0,0-.86-.23h-.08a14.76,14.76,0,0,0-2.2.45h0a5.08,5.08,0,0,1-1.89-.21h-.54a5.83,5.83,0,0,1-1.22,0c-.32,0-.56,0-.74,0h-.07A.86.86,0,0,0,152.3,280.46Zm6.67,4.18a.52.52,0,0,1,.45,0c.1.06.07.17-.07.25a.47.47,0,0,1-.44,0C158.8,284.84,158.83,284.72,159,284.64Zm-1.22-3.49a2,2,0,0,1,1.48-.22l.2.08c.4.23.29.67-.24,1a2.07,2.07,0,0,1-.58.23,1.59,1.59,0,0,1-1.1-.09C157.11,281.89,157.22,281.46,157.75,281.15Zm-5-.11a.5.5,0,0,1,.44,0c.11.06.08.18-.06.26a.52.52,0,0,1-.45,0C152.56,281.23,152.59,281.12,152.73,281Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,301.94l-16.8-9.7a.33.33,0,0,1-.15-.25v-.19a.33.33,0,0,1,.15-.25l22.2-12.82a.37.37,0,0,1,.29,0L164,288.44a.32.32,0,0,1,.14.24v.19a.34.34,0,0,1-.14.25l-22.21,12.82A.3.3,0,0,1,141.46,301.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,291.58s0,.1,0,.14l16.8,9.7a.25.25,0,0,0,.15,0V302a.37.37,0,0,1-.15,0l-16.8-9.7a.3.3,0,0,1-.14-.25v-.19A.36.36,0,0,1,124.62,291.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,288.46l0,0,0,0a.2.2,0,0,1,0,.08s0,0,0,0v.22a.35.35,0,0,1-.14.25l-22.21,12.82a.32.32,0,0,1-.14,0v-.52a.32.32,0,0,0,.14,0L164,288.6C164,288.56,164,288.5,164,288.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.44,281.69l-.2.11a.12.12,0,0,0,0,.22l13.49,7.79a.39.39,0,0,0,.39,0l.19-.11c.11-.06.11-.16,0-.22l-13.49-7.79A.42.42,0,0,0,145.44,281.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.26,282.37l-.19.11c-.11.06-.11.16,0,.22l13.49,7.79a.37.37,0,0,0,.38,0l.2-.11a.12.12,0,0,0,0-.22l-13.5-7.79A.42.42,0,0,0,144.26,282.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,283.05l-.2.11a.12.12,0,0,0,0,.22l13.49,7.79a.45.45,0,0,0,.39,0l.19-.11c.11-.06.11-.16,0-.22l-13.49-7.79A.42.42,0,0,0,143.09,283.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,284.55l-.19.11c-.11.06-.11.16,0,.22l13.49,7.79a.42.42,0,0,0,.38,0l.2-.11a.12.12,0,0,0,0-.22l-13.5-7.79A.42.42,0,0,0,140.49,284.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,285.23l-.19.11c-.11.06-.11.16,0,.22l13.49,7.79a.42.42,0,0,0,.38,0l.2-.11a.12.12,0,0,0,0-.22l-13.49-7.79A.45.45,0,0,0,139.31,285.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.14,285.9l-.2.12a.12.12,0,0,0,0,.22l13.5,7.79a.42.42,0,0,0,.38,0l.19-.11c.11-.07.11-.17,0-.23l-13.49-7.79A.42.42,0,0,0,138.14,285.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.54,287.4l-.19.12c-.11.06-.11.16,0,.22l13.49,7.79a.42.42,0,0,0,.38,0l.2-.12a.12.12,0,0,0,0-.22l-13.49-7.79A.45.45,0,0,0,135.54,287.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.36,288.08l-.19.12c-.11.06-.11.16,0,.22l13.49,7.79a.42.42,0,0,0,.38,0l.2-.11c.11-.07.11-.17,0-.23l-13.49-7.79A.45.45,0,0,0,134.36,288.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,288.76l-.19.11c-.11.07-.11.16,0,.23l13.49,7.79a.42.42,0,0,0,.38,0l.2-.12a.12.12,0,0,0,0-.22l-13.49-7.79A.44.44,0,0,0,133.19,288.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,285.4l-1.2-.94a.72.72,0,0,1-.06-.1s0,0,0,0l.29-.27.93-.85a.23.23,0,0,0,.09-.18v-.36a.37.37,0,0,0-.11-.24,1,1,0,0,1-.19-.46.81.81,0,0,1,.22-.43,1,1,0,0,0,.34-.92,1,1,0,0,0-.59-1.07,2.22,2.22,0,0,0-.92-.22h0a2.19,2.19,0,0,0-1.38.49,1.72,1.72,0,0,1-.89.34,2.89,2.89,0,0,1-.82,0,.68.68,0,0,0-.19,0h0a.5.5,0,0,0-.38.12l-.8.74-.3.27v0a.76.76,0,0,1-.68.09c-.44-.18-.65-.29-1.37-.61a1.58,1.58,0,0,0-.65-.14h0a2.16,2.16,0,0,0-1,.24v.36l9.9,5.72a.82.82,0,0,0,.19-.5v-.36A1,1,0,0,0,157.85,285.4Zm-2-5a1.32,1.32,0,0,1,1.29-.22.35.35,0,0,1,.14.06.66.66,0,0,1,.35.37.79.79,0,0,1-.19.27,1.13,1.13,0,0,1-.4.23,1.38,1.38,0,0,1-1-.06.77.77,0,0,1-.35-.37A.73.73,0,0,1,155.81,280.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,280.89l9.9,5.72c.27-.37.3-.75-.22-1.21l-1.2-.94s-.26-.29,0-.49l.29-.27.93-.85s.21-.15,0-.42a1,1,0,0,1,0-1.24,1,1,0,0,0-.25-1.64,2.22,2.22,0,0,0-.92-.22h0a2.19,2.19,0,0,0-1.38.49,1.72,1.72,0,0,1-.89.34,2.89,2.89,0,0,1-.82,0,.68.68,0,0,0-.19,0h0a.5.5,0,0,0-.38.12l-.8.74-.3.27v0a.76.76,0,0,1-.68.09c-.44-.18-.65-.29-1.37-.61a1.58,1.58,0,0,0-.65-.14h0A2.16,2.16,0,0,0,148.17,280.89Zm8.93-1.07a.35.35,0,0,1,.14.06.58.58,0,0,1,.16,1,1.13,1.13,0,0,1-.4.23,1.38,1.38,0,0,1-1-.06.58.58,0,0,1-.15-1A1.32,1.32,0,0,1,157.1,279.82Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.58,320a1.82,1.82,0,0,1-.86,1.43L192,332.28a1.93,1.93,0,0,1-1.72,0l-33-19a1.62,1.62,0,0,1,0-2.86L176,299.57a1.87,1.87,0,0,1,1.72,0l33,19A1.82,1.82,0,0,1,211.58,320Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.72,319.6,192,330.41a1.87,1.87,0,0,1-1.72,0l-33-19c-.47-.27-.47-.71,0-1L176,299.57a1.87,1.87,0,0,1,1.72,0l33,19A.52.52,0,0,1,210.72,319.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,330.62v1.86a1.71,1.71,0,0,0,.86-.2l18.73-10.82a1.82,1.82,0,0,0,.86-1.43,1.86,1.86,0,0,0-.77-1.37c.39.28.36.68-.09.94L192,330.42A1.82,1.82,0,0,1,191.13,330.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,318.64c.45-.26.42-.69.42-1.24V291.53A1.88,1.88,0,0,0,212,290l-33-19a1.82,1.82,0,0,0-1.67,0c-.44.25-.42.69-.42,1.24v25.87a1.94,1.94,0,0,0,.86,1.49l33,19A1.89,1.89,0,0,0,212.39,318.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,272.21c0-.55.39-.77.86-.5l33,19a1.71,1.71,0,0,1,.61.64l1.23-.71h0A1.71,1.71,0,0,0,212,290l-33-19a1.8,1.8,0,0,0-1.66,0C176.86,271.22,176.88,271.66,176.88,272.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.82,318.66a1.87,1.87,0,0,0,1.57,0c.44-.26.42-.69.42-1.24V291.53a1.7,1.7,0,0,0-.25-.85l-1.23.71h0a1.73,1.73,0,0,1,.25.85v25.87C211.58,318.62,211.25,318.85,210.82,318.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26,291.74l-31.8-18.35c-.28-.16-.51,0-.51.3v22.58a1.13,1.13,0,0,0,.51.89l31.8,18.36c.28.16.52,0,.52-.3V292.64A1.18,1.18,0,0,0,210.26,291.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34,318.66,177.73,301a1,1,0,0,0-.86,0l-.51.28a.26.26,0,0,0,0,.5L207,319.43a.93.93,0,0,0,.86,0l.5-.28A.26.26,0,0,0,208.34,318.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.94,320.08l-30.61-17.67a.86.86,0,0,0-.79,0l-8,4.6c-.2.11-.17.32.07.45l30.58,17.65a.87.87,0,0,0,.78.05l8-4.58C206.21,320.42,206.18,320.22,205.94,320.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,309.84l.92-.53s0-.06,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.55A.12.12,0,0,0,179.55,309.84Zm1.13-1.93-.92.53s0,.06,0,.08l1,.56a.15.15,0,0,0,.13,0l.92-.53s0-.05,0-.08l-1-.55A.18.18,0,0,0,180.68,307.91Zm3.09,1.79-.91.53a0,0,0,0,0,0,.08l1.63.94a.15.15,0,0,0,.13,0l.92-.53s0-.05,0-.08l-1.62-.93A.14.14,0,0,0,183.77,309.7Zm-1.69-1-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53s0-.05,0-.08l-.95-.55A.14.14,0,0,0,182.08,308.72Zm3.76,2.17-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53s0,0,0-.08l-1-.55A.17.17,0,0,0,185.84,310.89Zm1.4.81-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,187.24,311.7Zm-3.32,2.17.92-.53s0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.91.52s0,.06,0,.08l1,.56A.17.17,0,0,0,183.92,313.87Zm1.4.81.92-.53s0,0,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.91.53s0,.06,0,.08l1,.56A.17.17,0,0,0,185.32,314.68Zm1.4.81.92-.53s0-.06,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.91.53s0,.06,0,.08l1,.56A.17.17,0,0,0,186.72,315.49Zm1.4.81.92-.53s0-.06,0-.08l-1-.55a.12.12,0,0,0-.13,0l-.92.53s0,.06,0,.08l1,.55A.12.12,0,0,0,188.12,316.3ZM181,310.65l.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.55A.14.14,0,0,0,181,310.65Zm1.56,2.41.92-.53s0,0,0-.08l-.88-.51c-.05,0-.05-.06,0-.08l1.18-.68s0-.05,0-.08l-1.11-.64a.17.17,0,0,0-.14,0l-2.22,1.28s0,.06,0,.09l2.14,1.23A.14.14,0,0,0,182.52,313.06Zm6.12-.55-.92.53a0,0,0,0,0,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,188.64,312.51Zm1.4.81-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,190,313.32Zm8.81,8.11a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.56a.17.17,0,0,0,.14,0Zm2.4-1.64-.92.53s0,.06,0,.08l1,.55a.12.12,0,0,0,.13,0l.92-.53s0-.06,0-.08l-1-.55A.12.12,0,0,0,201.25,319.79Zm-.72,1.1a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm-4.65,1.4.92-.53s0-.06,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.91.53s0,.06,0,.08l1,.56A.17.17,0,0,0,195.88,322.29Zm2.32.28s0-.06,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.91.53s0,.06,0,.08l.95.56a.17.17,0,0,0,.14,0Zm1.64-3.59-.91.53s0,.06,0,.08l.95.56a.17.17,0,0,0,.14,0l.92-.53s0-.06,0-.08l-1-.55A.14.14,0,0,0,199.84,319Zm-7-4-.92.53s0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1-.56A.17.17,0,0,0,192.84,314.94Zm5.6,3.23-.91.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.92-.53s0-.06,0-.08l-1-.55A.14.14,0,0,0,198.44,318.17Zm-7-4-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1-.56A.17.17,0,0,0,191.44,314.13Zm2.8,1.62-.92.53s0,.05,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.52s0-.06,0-.08l-1-.56A.17.17,0,0,0,194.24,315.75Zm1.4.81-.91.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0l.92-.53s0-.05,0-.08l-1-.55A.14.14,0,0,0,195.64,316.56Zm1.4.8-.91.53a0,0,0,0,0,0,.08l1,.56a.17.17,0,0,0,.14,0l.92-.53s0-.05,0-.08l-1-.55A.17.17,0,0,0,197,317.36Zm-6.11.56.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.55A.14.14,0,0,0,190.93,317.92Zm-13.35-11.79-.92.53s0,0,0,.08l1,.55a.17.17,0,0,0,.14,0l.92-.53s0-.06,0-.08l-1-.56A.17.17,0,0,0,177.58,306.13Zm1.69,1-.91.53s0,.05,0,.08l.95.55c.05,0,.11,0,.14,0l.92-.53s0-.05,0-.08l-1-.55A.17.17,0,0,0,179.27,307.11Zm-3.09-1.79-.92.53s0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.56A.17.17,0,0,0,176.18,305.32Zm8,7.2.92-.53a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.56A.17.17,0,0,0,184.2,312.52ZM173.86,305s0,.06,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0Zm15.67,12.07.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.55A.14.14,0,0,0,189.53,317.11Zm-17.18-9.92.91-.53a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56A.17.17,0,0,0,172.35,307.19Zm2.71.05.91-.53s0,0,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56A.17.17,0,0,0,175.06,307.24Zm-2.51-1.44s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0l.91-.53s0,0,0-.08l-1-.55s-.11,0-.14,0Zm.61-.78-.95-.56a.17.17,0,0,0-.14,0l-2.23,1.28s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l2.22-1.28S173.21,305,173.16,305Zm3.11,1.86-.92.53a0,0,0,0,0,0,.08l1,.56a.17.17,0,0,0,.14,0l.92-.53s0,0,0-.08l-1-.55A.14.14,0,0,0,176.27,306.88ZM186.81,313l-.91.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,186.81,313Zm-12.15-5.5a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm10.75,4.69-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,185.41,312.16Zm12,8.46s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.56a.17.17,0,0,0,.14,0Zm.57-1.18-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,198,319.44Zm-2.89.9.92-.53s0-.05,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.52s0,.06,0,.08l1,.56A.17.17,0,0,0,195.13,320.34Zm-1.4-.81.91-.53s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55A.14.14,0,0,0,193.73,319.53Zm-1.4-.8.91-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55A.17.17,0,0,0,192.33,318.73Zm4.29-.1-.92.53s0,.06,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1-.55A.14.14,0,0,0,196.62,318.63Zm-1.4-.81-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53s0-.06,0-.08l-.95-.55A.14.14,0,0,0,195.22,317.82Zm-5.61-3.23-.91.53s0,.05,0,.08l.95.55a.17.17,0,0,0,.14,0l.92-.53s0-.06,0-.08l-1-.56A.17.17,0,0,0,189.61,314.59Zm1.4.81-.91.53s0,.05,0,.08l.95.55c.05,0,.11,0,.14,0l.92-.52s0-.06,0-.09l-1-.55A.17.17,0,0,0,191,315.4Zm-2.8-1.62-.91.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0l.92-.53s0-.06,0-.08l-1-.56A.17.17,0,0,0,188.21,313.78Zm5.61,3.23-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53s0,0,0-.08L194,317A.18.18,0,0,0,193.82,317Zm-1.4-.8-.92.52s0,.06,0,.09l1,.55a.15.15,0,0,0,.13,0l.92-.53s0,0,0-.08l-1-.55S192.45,316.18,192.42,316.21Zm2.06,5.27.92-.53s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.91.53a0,0,0,0,0,0,.08l1,.56A.17.17,0,0,0,194.48,321.48Zm7.26-.27,1,.55a.14.14,0,0,0,.14,0l.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53S201.7,321.19,201.74,321.21Zm-1.83.46,1.48.85a.17.17,0,0,0,.14,0l.91-.53s0-.05,0-.08l-1.47-.85a.17.17,0,0,0-.14,0l-.92.53S199.87,321.64,199.91,321.67Zm3.2-1.51,1.18.68a.14.14,0,0,0,.14,0l.91-.53s0-.06,0-.08l-1.18-.68a.17.17,0,0,0-.14,0l-.91.53S203.07,320.14,203.11,320.16Zm0-1.13s0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.91.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0Zm-4.88,3.18,1.85,1.07a.17.17,0,0,0,.14,0l.91-.53s0-.06,0-.08l-1.84-1.06a.14.14,0,0,0-.14,0l-.92.53A0,0,0,0,0,198.23,322.21Zm-.64,1.14,1.18.68a.14.14,0,0,0,.14,0l.91-.53s0-.06,0-.08l-1.18-.68a.12.12,0,0,0-.13,0l-.92.53S197.55,323.33,197.59,323.35ZM192.7,313a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm2.8,1.62a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0Zm6.21,3.58s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.91.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0Zm-7.61-4.39a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm2.8,1.61s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.91.53s0,.05,0,.08l1,.55a.14.14,0,0,0,.14,0Zm-.93,8.42s0,.05,0,.08l1.48.85a.17.17,0,0,0,.14,0l.91-.53s0-.05,0-.08l-1.47-.85a.17.17,0,0,0-.14,0Zm2.94-7.25s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.91.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0Zm1.4.8s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.91.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0ZM170,308.87a0,0,0,0,0,0,.08l2.36,1.37a.17.17,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-2.36-1.36a.14.14,0,0,0-.14,0Zm3.1,1.79s0,.06,0,.08l1,.55a.12.12,0,0,0,.13,0l.92-.53s0-.06,0-.08l-1-.55a.12.12,0,0,0-.13,0Zm20,10,.92-.53s0-.05,0-.08l-1-.55a.14.14,0,0,0-.14,0L192,320s0,0,0,.08l1,.55A.17.17,0,0,0,193.08,320.67Zm-17.16-8.39s0,.06,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0Zm-7.3-4.22s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0l.91-.53s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0Zm-1.39-.72,1,.55a.17.17,0,0,0,.14,0l2.22-1.28s0-.06,0-.08l-.95-.56a.17.17,0,0,0-.14,0l-2.23,1.29S167.19,307.31,167.23,307.34Zm13.92,8a0,0,0,0,0,0,.08l1.18.68a.14.14,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1.18-.68a.14.14,0,0,0-.14,0Zm-3.53-2s0,.05,0,.08l1.48.85a.17.17,0,0,0,.14,0l.91-.53s0-.05,0-.08l-1.48-.85a.17.17,0,0,0-.14,0Zm6.78,3.91s0,.06,0,.08l7.89,4.56a.15.15,0,0,0,.13,0l.92-.53s0,0,0-.08l-7.89-4.55a.15.15,0,0,0-.13,0Zm8.33,4.81s0,.06,0,.08l1.18.68a.14.14,0,0,0,.14,0l.91-.53a0,0,0,0,0,0-.08l-1.18-.68a.17.17,0,0,0-.14,0Zm-9.95-5.74s0,.05,0,.08L184,317a.17.17,0,0,0,.14,0l.92-.53s0-.05,0-.08l-1.18-.68a.17.17,0,0,0-.14,0Zm11.57,6.68a0,0,0,0,0,0,.08l1.18.68a.17.17,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1.18-.68a.14.14,0,0,0-.14,0Zm-14.82-8.56a0,0,0,0,0,0,.08l1.18.69a.17.17,0,0,0,.14,0l.92-.53a0,0,0,0,0,0-.08l-1.18-.68a.17.17,0,0,0-.14,0Zm-5-2.89s0,.06,0,.08l1,.55a.14.14,0,0,0,.14,0l.91-.53s0-.06,0-.08l-.95-.56a.17.17,0,0,0-.14,0Zm-2.08-2.71.91-.53s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55A.17.17,0,0,0,172.44,308.76Zm5.71.27.92-.53s0-.06,0-.08l-1-.55a.12.12,0,0,0-.13,0l-.92.53s0,.06,0,.08l.95.56A.17.17,0,0,0,178.15,309Zm3.72,5.17.92-.53s0-.05,0-.08L180,312a.14.14,0,0,0-.14,0l-.91.53a0,0,0,0,0,0,.08l2.81,1.62A.15.15,0,0,0,181.87,314.2ZM174.76,309s0,0,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0Zm.39-.22.92-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55A.14.14,0,0,0,175.15,308.81Zm8.13,6.2.91-.53s0-.05,0-.08l-1-.55a.18.18,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56A.17.17,0,0,0,183.28,315Zm-5.43-4.19s0-.05,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56a.15.15,0,0,0,.13,0Zm12.43,8.24.92-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55A.17.17,0,0,0,190.28,319.06Zm-1.4-.81.92-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55A.14.14,0,0,0,188.88,318.25Zm2.8,1.61.92-.52s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,0,0,.08l1,.55A.14.14,0,0,0,191.68,319.86Zm-5.6-3.23.91-.53a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0L185,316s0,.06,0,.08l1,.56A.17.17,0,0,0,186.08,316.63Zm1.4.81.91-.53a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55A.14.14,0,0,0,187.48,317.44Zm-2.8-1.62.91-.53a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56A.17.17,0,0,0,184.68,315.82Zm-7.54-11.4s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.24.14s0,.05,0,.08l.95.55a.17.17,0,0,0,.14,0Zm7.63,4s0-.05,0-.08l-.95-.55c-.05,0-.11,0-.14,0l-.92.53s0,.05,0,.08l1,.55a.17.17,0,0,0,.14,0Zm-2.8-1.61s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.91.53s0,0,0,.08l.95.55a.18.18,0,0,0,.14,0Zm4.51,2.6s0-.05,0-.08l-.95-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0Zm-3.11-1.79s0-.06,0-.08l-1-.56a.15.15,0,0,0-.13,0l-.92.53s0,.05,0,.08l1,.55s.1,0,.13,0Zm5.91,3.41a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm-1.4-.81a0,0,0,0,0,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.56a.17.17,0,0,0,.14,0Zm-7.94-4.2s0-.05,0-.08l-1-.55a.14.14,0,0,0-.14,0l-.24.14s0,.06,0,.08l1,.56a.15.15,0,0,0,.13,0Zm-4.2-2.42s0-.06,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.24.14a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Zm-1.26.72s0-.06,0-.08l-.95-.55a.14.14,0,0,0-.14,0l-.92.53s0,.06,0,.08l1,.55a.14.14,0,0,0,.14,0ZM171,308l.91-.53a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53s0,.05,0,.08l1,.55A.14.14,0,0,0,171,308Zm7.5-2.72s0-.05,0-.08l-1-.55a.17.17,0,0,0-.14,0l-.24.15s0,.05,0,.08l1,.55s.11,0,.14,0Zm12.15,6.63a0,0,0,0,0,0-.08l-1-.56a.17.17,0,0,0-.14,0l-.92.53a0,0,0,0,0,0,.08l1,.55a.14.14,0,0,0,.14,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.62 319.61 185.43 319.73 180.21 322.74 170.92 317.38 170.73 317.27 176.15 314.14 185.62 319.61",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.43 319.73 180.21 322.74 170.92 317.38 176.15 314.37 185.43 319.73",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.89,267.67c4.57.21,7.15.81,9.47,4.19s9.26,19.26,10.3,21.34,2,4.88.49,7.37-13.91,18.37-13.91,18.37l-4.77-7.13,8.94-13.65-9.73-15.25Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,267.67c1.62-.18,4.6-2.63,7.52-.52s4.23,6.1,6,9.89c1.2,2.57,7.7,16.87,8.17,18.23a5.39,5.39,0,0,1-.46,5.49c-1.59,2.29-6.57,8.25-6.57,8.25a9.35,9.35,0,0,1-6.13-6.83L380.9,298l-6.78-10.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,300.38l-2.22-3.24s-2.25-5-1.67-9.08c1.17-8.48.15-11.92-1.52-15.19l-6.59.53,2.78,14.52L380.9,298A12.67,12.67,0,0,0,383.34,300.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64,429.24s.74,2,1.17,3.75c.33,1.4.83,3.73.38,4.81s-2.35,1.83-5.33,1.92c-1.93.06-4.88,1.48-6.9,2.71s-6.48,1.9-8.74,1.72c-2.66-.21-5.47-1.64-5.94-2.72s-.88-2.57,6.21-5.14c.05,0,8.57-3.16,11.47-6.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64,429.43l-1.37-.11-6.31.36c-2.9,3.45-11.42,6.59-11.47,6.61l-1.14.43c-1.21,1-.09,2.72,2.89,2.87s12.07-3.3,14.08-4.36A6.09,6.09,0,0,0,353.64,429.43Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,426.72s.06,1.73.1,2.71-1.06,2.5-4.08,2.51c-2.12,0-3.62-.51-3.6-2.26l-.1-2.51Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.45,418.88c.55.2.7,1.25.81,3.33.08,1.57.45,4.31-1.39,4.88s-4.54.32-5.74-1.15a71.35,71.35,0,0,0-4.63-5.69c-1.85-1.94-3.84-3.75-4.61-6.49-.69-2.47-.15-3.56,1.54-4.3s3.25-.24,5.69,1.65a11.5,11.5,0,0,0,2.15,1C373.85,412.56,377.9,418.68,378.45,418.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.38,412.08l.08,7.43s-1.58,3.4-6.45.24c-.11-.24-.6-7.53-.6-7.53Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,412.14a11.5,11.5,0,0,1-2.15-1h0c-1.93-.54-5.93.32-4,3a21.56,21.56,0,0,0,5.9,5.61c2.19,1,2.89-.36,2.89-.36l-1-5.95A4.69,4.69,0,0,0,372.27,412.14Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,380a86.47,86.47,0,0,1-1.2-12.59s.62-12.19,1.28-24.5c1.46-27.39-.64-26.38-8.18-40.37,0,0-23.57-7.71-27.53,2.59,0,0-.88,9.47-1.11,16.1-.59,16.92-1.56,48.8-1.05,54.76s.1,8.86.77,21.48c.57,10.59,1.38,30,1.38,30,4.36,2.29,8.35-.74,8.35-.74s5.5-25.55,5.15-32.43c-.44-8.4-.21-15.39-.21-15.39s3.1-21.14,3.64-25.52c.16,10.6,2.45,21.61,4.16,31.91,2,11.84,4.71,28.72,4.71,28.72,4.35,2.29,7.28,1.06,7.28,1.06S382.43,388.28,381.17,380Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,380a86.47,86.47,0,0,1-1.2-12.59s.62-12.19,1.28-24.5c1.46-27.39-.64-26.38-8.18-40.37,0,0-23.57-7.71-27.53,2.59,0,0-.88,9.47-1.11,16.1-.59,16.92-1.56,48.8-1.05,54.76s.1,8.86.77,21.48c.57,10.59,1.38,30,1.38,30,4.36,2.29,8.35-.74,8.35-.74s5.5-25.55,5.15-32.43c-.44-8.4-.21-15.39-.21-15.39s3.1-21.14,3.64-25.52c.16,10.6,2.45,21.61,4.16,31.91,2,11.84,4.71,28.72,4.71,28.72,4.35,2.29,7.28,1.06,7.28,1.06S382.43,388.28,381.17,380Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,380a86.47,86.47,0,0,1-1.2-12.59s.62-12.19,1.28-24.5c1.46-27.39-.64-26.38-8.18-40.37,0,0-23.57-7.71-27.53,2.59,0,0-.88,9.47-1.11,16.1-.59,16.92-1.56,48.8-1.05,54.76s.1,8.86.77,21.48c.57,10.59,1.38,30,1.38,30,4.36,2.29,8.35-.74,8.35-.74s5.5-25.55,5.15-32.43c-.44-8.4-.21-15.39-.21-15.39s3.1-21.14,3.64-25.52c.16,10.6,2.45,21.61,4.16,31.91,2,11.84,4.71,28.72,4.71,28.72,4.35,2.29,7.28,1.06,7.28,1.06S382.43,388.28,381.17,380Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,330.13l-3.94,23.51c.16,8.51,1.66,17.27,3.14,25.71a203.36,203.36,0,0,1-1.25-25.17l4.35-22c5.42-.84,7.3-4.14,7.65-5.56C372.67,330.91,366.41,330.13,366.41,330.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.31 261.38 357.93 275.58 368.53 274.93 368.19 260.16 357.31 261.38",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.77,276.53c-.46-3.3-1.64-7.31-4.82-8.68a13.07,13.07,0,0,0-7.15-.42c-.45,1.51-5.93,3.44-8.64.84-2.63.55-5.85,1.15-9.39,2-2.81.68-4.45,11.31-6.29,14.73-2.18,4-.06,9.52,2.7,11.64,0,0,.05,3.87.36,8.43,4.84,4.05,13.89,5.16,20.88,3.34,5.26-1.38,6.73-3.13,7.85-6.88.47-1.56.89-2.92,1.87-5.64C378.41,289.59,379.39,280.92,378.77,276.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,265.21c-.6,0-1,.25-1.71,1.19-1,1.29-2.4,2.85-2.4,2.85s1.24,2.28,5.17,3.06a17.16,17.16,0,0,0,9.3-.39c2-.83,2.34-1.5,2.6-2.4a6.29,6.29,0,0,0-.81-3.62c-.58-1.26-1.32-1.2-1.32-1.2v1s-.21,1.09-3.25,1.62-6.64,0-7.52-.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.53,238a5.72,5.72,0,0,1,0-1.8,5.42,5.42,0,0,1,7.16-4.13,5.33,5.33,0,0,1,3-5.82,6.76,6.76,0,0,1,5.22.21,4.08,4.08,0,0,1,2.28,2,5.73,5.73,0,0,1,10.44,1.41c1.72-.39,4.16.38,4.94,2.1.87,1.95-.2,4.37.2,6.42.26,1.32.83,2.57,1.08,3.91a32.6,32.6,0,0,1,.42,4.53c.24,6.27-14.31,10.35-14,14.65l-7.76-9.44c0-.4-1.1-1.37-1.35-1.71-.46-.62-.87-1.29-1.3-1.94a12.18,12.18,0,0,0-5.35-4.27,9.91,9.91,0,0,1-3.82-3.14A6.74,6.74,0,0,1,342.53,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,248.43s-2.51,3.74-2.18,4.14a6.14,6.14,0,0,0,1.92.81Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,236.6c-2.45,1.24-6.67,3.53-7.76,12.38-1.11,9.08.94,12.24,2.2,13.43.86.8,5.24,1.1,7.53.4,2.87-.88,9.07-3.89,12-8.58,3.42-5.51,4.13-12.87.18-15.75C364.9,234.43,358.4,235.55,356.33,236.6Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,262.57c1,.57,4.07.87,6.37.45l-.07-1.74a16.37,16.37,0,0,1-3.14,1.09A10.32,10.32,0,0,1,351,262.57Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,236.33a9.58,9.58,0,0,0-2.84,1.64,3.74,3.74,0,0,0-1,1.29,3,3,0,0,0-.2,1.46,3.89,3.89,0,0,0,2.28,3.16,3.79,3.79,0,0,0-.61,3.16,7.54,7.54,0,0,0,2.24,3.23.46.46,0,0,0,.18.13c.14,0,.28,0,.41-.12,1.53-1,2.48-2.8,4.65-2.09,2.85.94,2.71,4.45.47,6.64a4.8,4.8,0,0,1-3,1.41,2.32,2.32,0,0,1-1.57-.55s.08,4.58,4.07,6.4a15.8,15.8,0,0,0,8.5.1c1.5-1.91,4-4.35,6.1-6.53,6.83-7.18,7.22-17.62-2.85-20.91-.35-.12-.7-.22-1.05-.31a21.54,21.54,0,0,0-14.64,1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.93,253.47a2.11,2.11,0,0,1-1.29-2.71,2.17,2.17,0,0,1,2.75-1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,270.45c-5.11.64-9.15,1.71-11.38,6.57-3.77,8.26-7.86,15-10.83,18.21-3.18,3.4-16.19,9.39-19.13,8.91s-5.86-3.85-7.37-3,1.29,4.15,1.11,4.88-5.14,0-8-1.43-5.21,2.06-2,5.87,11.13,3.95,17.77,2.61,19.16-4.82,24.25-9c6.17-5.09,8.27-8.94,10.9-13.5C353.25,280.78,348.39,270.45,348.39,270.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.2,270.18c-2.54-.44-7.71.29-9.69,2.57s-3.14,4.44-6,10.46-7,13.25-17.13,18c0,0,.93,6.35,4.37,8.63,0,0,7.27-1.49,11.55-4.58s10.32-10.41,12.83-14.33S352.19,283.35,349.2,270.18Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "108.4 285.6 107.35 297.25 94.38 294.78 95.73 282.74 108.4 285.6",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,270.93s2.82,4.29,2.5,4.71-2.4.8-2.4.8Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,259.08c5.72,1.2,7.37,3.72,7.91,12.8.56,9.48-.41,12.46-1.65,13.74-.85.86-5.52,1-7.88.37-3-.81-9.62-3.18-12.75-7.95-3.67-5.62-4.64-13.22-.7-16.35C99,257.3,106.2,258.59,108.52,259.08Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,284.66l-.06,1.6c2.45.3,5.74.07,6.44-.64l0,0a13.05,13.05,0,0,1-2.42,0A14.54,14.54,0,0,1,108.4,284.66Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69,263h0a13.1,13.1,0,0,1-5.53,1.74,11.18,11.18,0,0,1-.91,4.5c-.35,1-1.62,4.18-2.88,2.4-.91-1.29-1.74-2.46-3.54-2.19-3,.44-3.38,4.23-1.5,6.54s3.62,1.42,3.62,1.42-.09,5-2.31,7.85c0,0-2.53.82-7.18-.18-2.86-.6-6.9-4.18-8.6-8-3.59-8-3.84-15.2,1.27-17.35.55-3.69,3.45-5.34,6.76-6.1,4.59-1.06,9.26,1.91,13.71.12.94-.37,1.81-.92,2.76-1.24a1.88,1.88,0,0,1,1.64,0,2,2,0,0,1,.68,1.27,3.5,3.5,0,0,1-.24,2.63,7.94,7.94,0,0,1,2.09-.71,2.63,2.63,0,0,1,2.09.52,2.71,2.71,0,0,1,.8,1.84A5.65,5.65,0,0,1,117.69,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,261l-3.42-2A2,2,0,0,1,90,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,377.4c0-.12-.69-7.19-.69-7.19s.5.72,4.59.36a22.39,22.39,0,0,0,4.55-1.05l.27,5.13c.72,2.08,4.32,1.79,8.17,2,.65,0,1.32,0,2,0h0c2.06.24,3.9,1.82,1.48,3.19s-6,1.44-9.36,1.47C139.6,381.4,132.6,381.37,132.56,377.4Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,380.94a16.3,16.3,0,0,1-.17,1.88c-.14.76-2.54,3.23-6.09,4.23s-7.57.43-9.57.65-4,.79-6.37.95-4.93-.07-6.93-1.93c-.23-.55-.26-1.42-.1-1.54C131.23,384.86,160,380.94,160,380.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,375.41c1.28,1.25,4.39,1.06,7.69,1.25,3.11.18,6.73-.31,8.68.77s3.25,3.73-.09,6.38a19.42,19.42,0,0,1-4.06,2c-3.5,1.37-7.17.66-9.51.83-3,.22-4.85,1.23-7.61,1.08-3.56-.19-5.61-1.46-6.05-2.5s.28-8.65,1.75-8.23c0,0,.21,2.54,6.32,1.15C141.54,377.5,141.76,376,141.76,375.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,331.68c.29,7.08,0,40,0,40a10.76,10.76,0,0,1-9.83,1.76l-3.41-37.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,389.54c0-.12-1.29-6.88-1.29-6.88s1.29.86,5.38.62a18.51,18.51,0,0,0,4-.75l.66,5c.65,2.1,4.26,1.93,8.11,2.26.64.06,1.31.08,2,.1H171c2.05.3,3.84,1.93,1.38,3.23s-6.08,1.25-9.4,1.18C159,394.2,152,393.5,152,389.54Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,394.31a3.77,3.77,0,0,1-.19,2.12c-.42,1.21-3.34,2.94-6.95,3.69s-7.57.15-9.57.32-4.19.91-6.53,1a9.46,9.46,0,0,1-6.43-2.18c-.31-.49-.4-1.43-.24-1.55C150.48,397.4,180,394.31,180,394.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.29,388.28c1.24,1.28,4.35,1.2,7.65,1.48,3.1.27,6.73-.1,8.65,1s3.95,3.65.53,6.2a20.56,20.56,0,0,1-5,2.2c-3.61,1-7.16.25-9.5.35-3,.13-4.89,1.09-7.64.86-3.55-.3-5.57-1.64-6-2.69s.55-8.63,2-8.17c0,0,.14,2.54,6.29,1.34C161,390.36,161.27,388.84,161.29,388.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91,345.43c.82,7.33,1.6,28.56,2.15,39.16a14.65,14.65,0,0,1-10.59,1.18l-7.55-38.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,432.32a.89.89,0,0,0,.89-.89V374.55a.89.89,0,0,0-1.77,0v56.88A.88.88,0,0,0,111.37,432.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,411.61a.88.88,0,0,0,.82-.56l17.44-44.14a.88.88,0,1,0-1.64-.65L75.36,410.4a.88.88,0,0,0,.49,1.15A1,1,0,0,0,76.18,411.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27,406.31a.88.88,0,0,0,.65-.28l32.45-34.34,32.4,34.2a.88.88,0,0,0,1.28-1.22l-33-34.88a.89.89,0,0,0-.64-.27h0a.91.91,0,0,0-.64.27l-33.1,35a.89.89,0,0,0,.64,1.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.56,411.61a1,1,0,0,0,.33-.06.89.89,0,0,0,.5-1.15l-17.45-44.14a.88.88,0,1,0-1.64.65l17.44,44.14A.88.88,0,0,0,146.56,411.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,355c.63-3.56-2.27-6.35-7.74-10a128.3,128.3,0,0,0-15.85-8.9c-4.57-2.1-9.25-1.91-15.11,1.1-8.14,4.18-32.62,19-32.62,19S112.28,376.9,119.32,376,144,363.6,145.37,359.57,147,355,147,355Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,371.63c5.25,4.76,10.74.66,19.44-5C145.06,360.27,147,355,147,355a21.41,21.41,0,0,1-.73,5.75c-.74,1.84-2.33,3.92-9.42,8.81s-12.23,7.34-17,8.24l-3.76-.52",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,366.65C145.06,360.27,147,355,147,355a21.41,21.41,0,0,1-.73,5.75c-.74,1.84-2.33,3.92-9.42,8.81s-12.23,7.34-17,8.24l-3.76-.52-.29-5.69C121,376.39,126.53,372.29,135.23,366.65Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,405,75.08,411a.41.41,0,0,0,0,.16.2.2,0,0,0,0,.11.71.71,0,0,0,.34.38,1.53,1.53,0,0,0,1.41,0,.57.57,0,0,0,.27-.29h0l0-.08,2.14-5.7Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,405l2.31,6.08a.78.78,0,0,1,0,.16v.11a.73.73,0,0,1-.35.38,1.51,1.51,0,0,1-1.4,0,.56.56,0,0,1-.28-.29h0l0-.08-2.14-5.7Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,427v5a.52.52,0,0,0,.3.42,1.59,1.59,0,0,0,1.44,0,.52.52,0,0,0,.3-.42v-5A2.17,2.17,0,0,0,110.35,427Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.16,340.9s29.37-8.87,34.47-10.27,14.9-3.75,17.77-2.47,4.31,2.77,4.57,6.9c.06.78,0,4.56,0,4.56s-14.87,6.05-26.5,6.05S87.16,340.9,87.16,340.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,337.22c-1.84,6.28-2.42,12.43,2,17,3.2,3.3,16.48,15.07,28.11,11.5,13-4,28.53-15.27,28.53-15.27s10,.31,10.09-2.64c0-.72,3.17-1.61,3.14-2.4-.41-8.65-6.23-12.25-14.91-10.68-9.11,1.65-29.47,7.46-29.47,7.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,363.4c-2.19-8-4.81-18.14-4.81-18.14l12,3.79c2.48,7.84,3.73,12.1,9.93,11.09s27-9.72,27-9.72-15.53,11.29-28.53,15.27C111.94,367.29,106.4,365.81,101.59,363.4Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,291c-4-.88-8.28,2-10.74,8.23S70.63,320.86,69.63,325c-.45,1.86,14.84,18.61,14.33,18.37-.15-.08,4.49-8.09,4.49-8.09L80.68,325l4.93-11.58Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,290.35c-5.22-1.46-8.8.26-11.14,5.9S74.42,308.06,71.41,318c0,0,10.51,6.49,17.43,3.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,295.57c1.66-3.8,3.66-5.32,7.86-5.23,1.41,0,3.88.32,3.88.32.5,2,8.64,3.89,13,1.61,1.59.41,5.76,1.23,7.08,1.67,3.79,1.26,4.37,5.59,5,17.95,0,0,0,26.25-.85,33.61-5.37,6.84-18.47,5.91-23.93,4.84C83.71,348.13,81.93,342,81.93,342s-1.18-21.59-1.05-30.55C81,303.86,82.17,297.72,83.1,295.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,316.14c-1.84.87-24.06,18.5-27.51,16.7s-16.44-21.26-16.44-21.26a29.33,29.33,0,0,1,1.37-17.4c3.15.3,5,.12,8.06,5.56C125.94,304.37,134,320,134,320q4.65-2.46,9.26-5c2.53-1.39,5.07-2.77,7.55-4.26a9.23,9.23,0,0,0,1.94-1.26c1.21-1.25.93-4.2.87-5.81a18.93,18.93,0,0,0-.16-2.26c-.12-.91-.35-3.16,1.32-2.48a2.1,2.1,0,0,1,.81.64,3.61,3.61,0,0,1,.62,1.12c.33,1,.25,2,.56,3a.89.89,0,0,0,.21.38.71.71,0,0,0,.53.15c2.41-.13,4.62-3.56,5.68-5.37A4.93,4.93,0,0,1,165,296.7c1.3-.65,2.91.2,3.78,1.36a7.65,7.65,0,0,1,1.32,5.29,10.56,10.56,0,0,1-3,6.73A32.3,32.3,0,0,1,157.85,316.14Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08,377.32c-3-.15-5.34-2.34-12.45-5.31-13.14-5.47-23-9.85-26.75-16.74s-6.41-26.74-5.48-35.35a11.45,11.45,0,0,1,.65-2.85l-.93-.13,2.4-2h0c2.45-2,6.45-.22,9.46,1.42,8.6,4.68,15.33,9.22,20.65,25.65,4,12.35,6.63,23.62,12.16,29.65",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.05,317.07l-.93-.13,2.4-2h0c2.45-2,6.45-.22,9.46,1.42,8.6,4.68,15.33,9.22,20.65,25.65,4,12.35,6.63,23.62,12.16,29.65l.29,5.69c-3-.15-5.34-2.34-12.45-5.31-13.14-5.47-23-9.85-26.75-16.74s-6.42-26.74-5.48-35.35A11.45,11.45,0,0,1,72.05,317.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49,318.44c8.6,4.68,15.32,9.23,20.64,25.65s8.23,30.94,18.71,33.75c0,0-4.74,1.89-19.26-4.26C96,371.63,90.35,368.07,86.67,366c-7.22-4.05-11.59-7.37-12.28-8.61C70.57,350.54,68,330.64,68.91,322S76.18,316.1,80.49,318.44Z",
    style: {
      fill: "#BDDEF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,289.86c-5.31,1.72-11.51.48-12.82-2.26l.11-1s-.59-.82-1.44.75-1.75,3-1.75,3-.5,3.24,4.34,5.17A13.9,13.9,0,0,0,108,294.8c1.81-1.13,2.81-1.85,2.81-1.85l1.45.32s-1.8-2.77-2.65-4-1.45-1.21-1.45-1.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,293.94c3.78.33,5,0,7.41,3.31s11.8,22.18,11.8,22.18l13.24-6.62,5.18,7.11s-15,11.4-18.14,13.06-4.18,1.73-6.88-1.3-13.3-18.93-13.3-18.93S109.75,305,114.88,293.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBimg1);
export default __webpack_public_path__ + "static/media/bimg1.c7437cd60cffbd524ce63ae3a4e29b90.svg";
export { ForwardRef as ReactComponent };